/// Auto-generated. Modifications will be overwritten.
/// Generated from core/document-schemas/BarcodeDocumentModel.yaml
/** Boarding Pass */
export class BoardingPass {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BoardingPass.DOCUMENT_TYPE;
    }
    /** Electronic Ticket */
    get electronicTicketIndicator() {
        return this.document.fields.find((f) => f.type.name === 'ElectronicTicketIndicator');
    }
    /** Format Code. */
    get formatCode() {
        return this.document.fields.find((f) => f.type.name === 'FormatCode');
    }
    /** Number of encoded legs. */
    get numberOfLegs() {
        return this.document.fields.find((f) => f.type.name === 'NumberOfLegs');
    }
    /** Passenger Name */
    get passengerName() {
        return this.document.fields.find((f) => f.type.name === 'PassengerName');
    }
    /** Security Data */
    get securityData() {
        return this.document.fields.find((f) => f.type.name === 'SecurityData');
    }
    /** Security Data Type */
    get securityDataType() {
        return this.document.fields.find((f) => f.type.name === 'SecurityDataType');
    }
    /** An array of all children of type "Leg". */
    get legs() {
        return this.document.children
            .filter((c) => c.type.name === 'Leg')
            .map((c) => new BoardingPass.Leg(c));
    }
}
BoardingPass.DOCUMENT_TYPE = 'BoardingPass';
BoardingPass.ELECTRONIC_TICKET_INDICATOR_FIELD_NAME = 'ElectronicTicketIndicator';
BoardingPass.ELECTRONIC_TICKET_INDICATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.ElectronicTicketIndicator';
BoardingPass.FORMAT_CODE_FIELD_NAME = 'FormatCode';
BoardingPass.FORMAT_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.FormatCode';
BoardingPass.NUMBER_OF_LEGS_FIELD_NAME = 'NumberOfLegs';
BoardingPass.NUMBER_OF_LEGS_FIELD_NAME_NORMALIZED = 'BoardingPass.NumberOfLegs';
BoardingPass.PASSENGER_NAME_FIELD_NAME = 'PassengerName';
BoardingPass.PASSENGER_NAME_FIELD_NAME_NORMALIZED = 'BoardingPass.PassengerName';
BoardingPass.SECURITY_DATA_FIELD_NAME = 'SecurityData';
BoardingPass.SECURITY_DATA_FIELD_NAME_NORMALIZED = 'BoardingPass.SecurityData';
BoardingPass.SECURITY_DATA_TYPE_FIELD_NAME = 'SecurityDataType';
BoardingPass.SECURITY_DATA_TYPE_FIELD_NAME_NORMALIZED = 'BoardingPass.SecurityDataType';
(function (BoardingPass) {
    /** Leg of the journey */
    class Leg {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return BoardingPass.Leg.DOCUMENT_TYPE;
        }
        /** Airline Designator Of Boarding Pass Issuer */
        get airlineDesignatorOfBoardingPassIssuer() {
            return this.document.fields.find((f) => f.type.name === 'AirlineDesignatorOfBoardingPassIssuer');
        }
        /** Airline Numeric Code */
        get airlineNumericCode() {
            return this.document.fields.find((f) => f.type.name === 'AirlineNumericCode');
        }
        /** Baggage Tag License Plate Numbers */
        get baggageTagLicensePlateNumbers() {
            return this.document.fields.find((f) => f.type.name === 'BaggageTagLicensePlateNumbers');
        }
        /** Check In Sequence Number */
        get checkInSequenceNumber() {
            return this.document.fields.find((f) => f.type.name === 'CheckInSequenceNumber');
        }
        /** Compartment Code */
        get compartmentCode() {
            return this.document.fields.find((f) => f.type.name === 'CompartmentCode');
        }
        /** Date Of Boarding Pass Issuance Julian */
        get dateOfBoardingPassIssuanceJulian() {
            return this.document.fields.find((f) => f.type.name === 'DateOfBoardingPassIssuanceJulian');
        }
        /** Date Of Flight Julian */
        get dateOfFlightJulian() {
            return this.document.fields.find((f) => f.type.name === 'DateOfFlightJulian');
        }
        /** Departure Airport Code */
        get departureAirportCode() {
            return this.document.fields.find((f) => f.type.name === 'DepartureAirportCode');
        }
        /** Destination Airport Code */
        get destinationAirportCode() {
            return this.document.fields.find((f) => f.type.name === 'DestinationAirportCode');
        }
        /** Document Form Serial Number */
        get documentFormSerialNumber() {
            return this.document.fields.find((f) => f.type.name === 'DocumentFormSerialNumber');
        }
        /** Document Type */
        get documentType() {
            return this.document.fields.find((f) => f.type.name === 'DocumentType');
        }
        /** Fast Track */
        get fastTrack() {
            return this.document.fields.find((f) => f.type.name === 'FastTrack');
        }
        /** First Non Consecutive Baggage Tag License Plate Number */
        get firstNonConsecutiveBaggageTagLicensePlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'FirstNonConsecutiveBaggageTagLicensePlateNumber');
        }
        /** Flight Number */
        get flightNumber() {
            return this.document.fields.find((f) => f.type.name === 'FlightNumber');
        }
        /** For Individual Airline Use */
        get forIndividualAirlineUse() {
            return this.document.fields.find((f) => f.type.name === 'ForIndividualAirlineUse');
        }
        /** Free Baggage Allowance */
        get freeBaggageAllowance() {
            return this.document.fields.find((f) => f.type.name === 'FreeBaggageAllowance');
        }
        /** Frequent Flyer Airline Designator */
        get frequentFlyerAirlineDesignator() {
            return this.document.fields.find((f) => f.type.name === 'FrequentFlyerAirlineDesignator');
        }
        /** Frequent Flyer Number */
        get frequentFlyerNumber() {
            return this.document.fields.find((f) => f.type.name === 'FrequentFlyerNumber');
        }
        /** IDAD Indicator */
        get idadIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IDADIndicator');
        }
        /** International Documentation Verification */
        get internationalDocumentationVerification() {
            return this.document.fields.find((f) => f.type.name === 'InternationalDocumentationVerification');
        }
        /** Marketing Carrier Designator */
        get marketingCarrierDesignator() {
            return this.document.fields.find((f) => f.type.name === 'MarketingCarrierDesignator');
        }
        /** Operating Carrier Designator */
        get operatingCarrierDesignator() {
            return this.document.fields.find((f) => f.type.name === 'OperatingCarrierDesignator');
        }
        /** Operating Carrier PNR Code */
        get operatingCarrierPNRCode() {
            return this.document.fields.find((f) => f.type.name === 'OperatingCarrierPNRCode');
        }
        /** Passenger Description */
        get passengerDescription() {
            return this.document.fields.find((f) => f.type.name === 'PassengerDescription');
        }
        /** Passenger Status */
        get passengerStatus() {
            return this.document.fields.find((f) => f.type.name === 'PassengerStatus');
        }
        /** Seat Number */
        get seatNumber() {
            return this.document.fields.find((f) => f.type.name === 'SeatNumber');
        }
        /** Second Non Consecutive Baggage Tag License Plate Number */
        get secondNonConsecutiveBaggageTagLicensePlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'SecondNonConsecutiveBaggageTagLicensePlateNumber');
        }
        /** Selectee Indicator */
        get selecteeIndicator() {
            return this.document.fields.find((f) => f.type.name === 'SelecteeIndicator');
        }
        /** Source Of Boarding Pass Issuance */
        get sourceOfBoardingPassIssuance() {
            return this.document.fields.find((f) => f.type.name === 'SourceOfBoardingPassIssuance');
        }
        /** Source Of Check In */
        get sourceOfCheckIn() {
            return this.document.fields.find((f) => f.type.name === 'SourceOfCheckIn');
        }
        /** VersionNumber */
        get versionNumber() {
            return this.document.fields.find((f) => f.type.name === 'VersionNumber');
        }
    }
    Leg.DOCUMENT_TYPE = 'Leg';
    Leg.AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER_FIELD_NAME = 'AirlineDesignatorOfBoardingPassIssuer';
    Leg.AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.AirlineDesignatorOfBoardingPassIssuer';
    Leg.AIRLINE_NUMERIC_CODE_FIELD_NAME = 'AirlineNumericCode';
    Leg.AIRLINE_NUMERIC_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.AirlineNumericCode';
    Leg.BAGGAGE_TAG_LICENSE_PLATE_NUMBERS_FIELD_NAME = 'BaggageTagLicensePlateNumbers';
    Leg.BAGGAGE_TAG_LICENSE_PLATE_NUMBERS_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.BaggageTagLicensePlateNumbers';
    Leg.CHECK_IN_SEQUENCE_NUMBER_FIELD_NAME = 'CheckInSequenceNumber';
    Leg.CHECK_IN_SEQUENCE_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.CheckInSequenceNumber';
    Leg.COMPARTMENT_CODE_FIELD_NAME = 'CompartmentCode';
    Leg.COMPARTMENT_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.CompartmentCode';
    Leg.DATE_OF_BOARDING_PASS_ISSUANCE_JULIAN_FIELD_NAME = 'DateOfBoardingPassIssuanceJulian';
    Leg.DATE_OF_BOARDING_PASS_ISSUANCE_JULIAN_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DateOfBoardingPassIssuanceJulian';
    Leg.DATE_OF_FLIGHT_JULIAN_FIELD_NAME = 'DateOfFlightJulian';
    Leg.DATE_OF_FLIGHT_JULIAN_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DateOfFlightJulian';
    Leg.DEPARTURE_AIRPORT_CODE_FIELD_NAME = 'DepartureAirportCode';
    Leg.DEPARTURE_AIRPORT_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DepartureAirportCode';
    Leg.DESTINATION_AIRPORT_CODE_FIELD_NAME = 'DestinationAirportCode';
    Leg.DESTINATION_AIRPORT_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DestinationAirportCode';
    Leg.DOCUMENT_FORM_SERIAL_NUMBER_FIELD_NAME = 'DocumentFormSerialNumber';
    Leg.DOCUMENT_FORM_SERIAL_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DocumentFormSerialNumber';
    Leg.DOCUMENT_TYPE_FIELD_NAME = 'DocumentType';
    Leg.DOCUMENT_TYPE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.DocumentType';
    Leg.FAST_TRACK_FIELD_NAME = 'FastTrack';
    Leg.FAST_TRACK_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FastTrack';
    Leg.FIRST_NON_CONSECUTIVE_BAGGAGE_TAG_LICENSE_PLATE_NUMBER_FIELD_NAME = 'FirstNonConsecutiveBaggageTagLicensePlateNumber';
    Leg.FIRST_NON_CONSECUTIVE_BAGGAGE_TAG_LICENSE_PLATE_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FirstNonConsecutiveBaggageTagLicensePlateNumber';
    Leg.FLIGHT_NUMBER_FIELD_NAME = 'FlightNumber';
    Leg.FLIGHT_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FlightNumber';
    Leg.FOR_INDIVIDUAL_AIRLINE_USE_FIELD_NAME = 'ForIndividualAirlineUse';
    Leg.FOR_INDIVIDUAL_AIRLINE_USE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.ForIndividualAirlineUse';
    Leg.FREE_BAGGAGE_ALLOWANCE_FIELD_NAME = 'FreeBaggageAllowance';
    Leg.FREE_BAGGAGE_ALLOWANCE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FreeBaggageAllowance';
    Leg.FREQUENT_FLYER_AIRLINE_DESIGNATOR_FIELD_NAME = 'FrequentFlyerAirlineDesignator';
    Leg.FREQUENT_FLYER_AIRLINE_DESIGNATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FrequentFlyerAirlineDesignator';
    Leg.FREQUENT_FLYER_NUMBER_FIELD_NAME = 'FrequentFlyerNumber';
    Leg.FREQUENT_FLYER_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.FrequentFlyerNumber';
    Leg.IDAD_INDICATOR_FIELD_NAME = 'IDADIndicator';
    Leg.IDAD_INDICATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.IDADIndicator';
    Leg.INTERNATIONAL_DOCUMENTATION_VERIFICATION_FIELD_NAME = 'InternationalDocumentationVerification';
    Leg.INTERNATIONAL_DOCUMENTATION_VERIFICATION_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.InternationalDocumentationVerification';
    Leg.MARKETING_CARRIER_DESIGNATOR_FIELD_NAME = 'MarketingCarrierDesignator';
    Leg.MARKETING_CARRIER_DESIGNATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.MarketingCarrierDesignator';
    Leg.OPERATING_CARRIER_DESIGNATOR_FIELD_NAME = 'OperatingCarrierDesignator';
    Leg.OPERATING_CARRIER_DESIGNATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.OperatingCarrierDesignator';
    Leg.OPERATING_CARRIER_PNR_CODE_FIELD_NAME = 'OperatingCarrierPNRCode';
    Leg.OPERATING_CARRIER_PNR_CODE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.OperatingCarrierPNRCode';
    Leg.PASSENGER_DESCRIPTION_FIELD_NAME = 'PassengerDescription';
    Leg.PASSENGER_DESCRIPTION_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.PassengerDescription';
    Leg.PASSENGER_STATUS_FIELD_NAME = 'PassengerStatus';
    Leg.PASSENGER_STATUS_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.PassengerStatus';
    Leg.SEAT_NUMBER_FIELD_NAME = 'SeatNumber';
    Leg.SEAT_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.SeatNumber';
    Leg.SECOND_NON_CONSECUTIVE_BAGGAGE_TAG_LICENSE_PLATE_NUMBER_FIELD_NAME = 'SecondNonConsecutiveBaggageTagLicensePlateNumber';
    Leg.SECOND_NON_CONSECUTIVE_BAGGAGE_TAG_LICENSE_PLATE_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.SecondNonConsecutiveBaggageTagLicensePlateNumber';
    Leg.SELECTEE_INDICATOR_FIELD_NAME = 'SelecteeIndicator';
    Leg.SELECTEE_INDICATOR_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.SelecteeIndicator';
    Leg.SOURCE_OF_BOARDING_PASS_ISSUANCE_FIELD_NAME = 'SourceOfBoardingPassIssuance';
    Leg.SOURCE_OF_BOARDING_PASS_ISSUANCE_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.SourceOfBoardingPassIssuance';
    Leg.SOURCE_OF_CHECK_IN_FIELD_NAME = 'SourceOfCheckIn';
    Leg.SOURCE_OF_CHECK_IN_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.SourceOfCheckIn';
    Leg.VERSION_NUMBER_FIELD_NAME = 'VersionNumber';
    Leg.VERSION_NUMBER_FIELD_NAME_NORMALIZED = 'BoardingPass.Leg.VersionNumber';
    BoardingPass.Leg = Leg;
})(BoardingPass || (BoardingPass = {}));
/** SwissQR */
export class SwissQR {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return SwissQR.DOCUMENT_TYPE;
    }
    /** Additional Billing Information */
    get additionalBillingInformation() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalBillingInformation');
    }
    /** Additional Info Trailer */
    get additionalInfoTrailer() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalInfoTrailer');
    }
    /** Additional Info Unstructured */
    get additionalInfoUnstructured() {
        return this.document.fields.find((f) => f.type.name === 'AdditionalInfoUnstructured');
    }
    /** Alternative Procedure Parameter */
    get alternativeProcedureParameter() {
        return this.document.fields.find((f) => f.type.name === 'AlternativeProcedureParameter');
    }
    /** Amount */
    get amount() {
        return this.document.fields.find((f) => f.type.name === 'Amount');
    }
    /** Currency */
    get currency() {
        return this.document.fields.find((f) => f.type.name === 'Currency');
    }
    /** Debtor Address Type */
    get debtorAddressType() {
        return this.document.fields.find((f) => f.type.name === 'DebtorAddressType');
    }
    /** Debtor Building Or Address Line 2 */
    get debtorBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'DebtorBuildingOrAddressLine2');
    }
    /** Debtor Country */
    get debtorCountry() {
        return this.document.fields.find((f) => f.type.name === 'DebtorCountry');
    }
    /** Debtor Name */
    get debtorName() {
        return this.document.fields.find((f) => f.type.name === 'DebtorName');
    }
    /** Debtor Place */
    get debtorPlace() {
        return this.document.fields.find((f) => f.type.name === 'DebtorPlace');
    }
    /** Debtor Postal Code */
    get debtorPostalCode() {
        return this.document.fields.find((f) => f.type.name === 'DebtorPostalCode');
    }
    /** Debtor Street Or Address Line 1 */
    get debtorStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'DebtorStreetOrAddressLine1');
    }
    /** Due Date */
    get dueDate() {
        return this.document.fields.find((f) => f.type.name === 'DueDate');
    }
    /** Encoding */
    get encoding() {
        return this.document.fields.find((f) => f.type.name === 'Encoding');
    }
    /** Final Payee Address Type */
    get finalPayeeAddressType() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeAddressType');
    }
    /** Final Payee Building Or Address Line 2 */
    get finalPayeeBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeBuildingOrAddressLine2');
    }
    /** Final Payee Country */
    get finalPayeeCountry() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeCountry');
    }
    /** Final Payee Name */
    get finalPayeeName() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeName');
    }
    /** Final Payee Place */
    get finalPayeePlace() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeePlace');
    }
    /** Final Payee Postal Code */
    get finalPayeePostalCode() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeePostalCode');
    }
    /** Final Payee Street Or Address Line 1 */
    get finalPayeeStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'FinalPayeeStreetOrAddressLine1');
    }
    /** IBAN */
    get iban() {
        return this.document.fields.find((f) => f.type.name === 'IBAN');
    }
    /** Major Version */
    get majorVersion() {
        return this.document.fields.find((f) => f.type.name === 'MajorVersion');
    }
    /** Payee Address Type */
    get payeeAddressType() {
        return this.document.fields.find((f) => f.type.name === 'PayeeAddressType');
    }
    /** Payee Building Or Address Line 2 */
    get payeeBuildingOrAddressLine2() {
        return this.document.fields.find((f) => f.type.name === 'PayeeBuildingOrAddressLine2');
    }
    /** Payee Country */
    get payeeCountry() {
        return this.document.fields.find((f) => f.type.name === 'PayeeCountry');
    }
    /** Payee Name */
    get payeeName() {
        return this.document.fields.find((f) => f.type.name === 'PayeeName');
    }
    /** Payee Place */
    get payeePlace() {
        return this.document.fields.find((f) => f.type.name === 'PayeePlace');
    }
    /** Payee Postal Code */
    get payeePostalCode() {
        return this.document.fields.find((f) => f.type.name === 'PayeePostalCode');
    }
    /** Payee Street Or Address Line 1 */
    get payeeStreetOrAddressLine1() {
        return this.document.fields.find((f) => f.type.name === 'PayeeStreetOrAddressLine1');
    }
    /** Payment Reference */
    get paymentReference() {
        return this.document.fields.find((f) => f.type.name === 'PaymentReference');
    }
    /** Payment Reference Type */
    get paymentReferenceType() {
        return this.document.fields.find((f) => f.type.name === 'PaymentReferenceType');
    }
}
SwissQR.DOCUMENT_TYPE = 'SwissQR';
SwissQR.ADDITIONAL_BILLING_INFORMATION_FIELD_NAME = 'AdditionalBillingInformation';
SwissQR.ADDITIONAL_BILLING_INFORMATION_FIELD_NAME_NORMALIZED = 'SwissQR.AdditionalBillingInformation';
SwissQR.ADDITIONAL_INFO_TRAILER_FIELD_NAME = 'AdditionalInfoTrailer';
SwissQR.ADDITIONAL_INFO_TRAILER_FIELD_NAME_NORMALIZED = 'SwissQR.AdditionalInfoTrailer';
SwissQR.ADDITIONAL_INFO_UNSTRUCTURED_FIELD_NAME = 'AdditionalInfoUnstructured';
SwissQR.ADDITIONAL_INFO_UNSTRUCTURED_FIELD_NAME_NORMALIZED = 'SwissQR.AdditionalInfoUnstructured';
SwissQR.ALTERNATIVE_PROCEDURE_PARAMETER_FIELD_NAME = 'AlternativeProcedureParameter';
SwissQR.ALTERNATIVE_PROCEDURE_PARAMETER_FIELD_NAME_NORMALIZED = 'SwissQR.AlternativeProcedureParameter';
SwissQR.AMOUNT_FIELD_NAME = 'Amount';
SwissQR.AMOUNT_FIELD_NAME_NORMALIZED = 'SwissQR.Amount';
SwissQR.CURRENCY_FIELD_NAME = 'Currency';
SwissQR.CURRENCY_FIELD_NAME_NORMALIZED = 'SwissQR.Currency';
SwissQR.DEBTOR_ADDRESS_TYPE_FIELD_NAME = 'DebtorAddressType';
SwissQR.DEBTOR_ADDRESS_TYPE_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorAddressType';
SwissQR.DEBTOR_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME = 'DebtorBuildingOrAddressLine2';
SwissQR.DEBTOR_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorBuildingOrAddressLine2';
SwissQR.DEBTOR_COUNTRY_FIELD_NAME = 'DebtorCountry';
SwissQR.DEBTOR_COUNTRY_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorCountry';
SwissQR.DEBTOR_NAME_FIELD_NAME = 'DebtorName';
SwissQR.DEBTOR_NAME_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorName';
SwissQR.DEBTOR_PLACE_FIELD_NAME = 'DebtorPlace';
SwissQR.DEBTOR_PLACE_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorPlace';
SwissQR.DEBTOR_POSTAL_CODE_FIELD_NAME = 'DebtorPostalCode';
SwissQR.DEBTOR_POSTAL_CODE_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorPostalCode';
SwissQR.DEBTOR_STREET_OR_ADDRESS_LINE_1_FIELD_NAME = 'DebtorStreetOrAddressLine1';
SwissQR.DEBTOR_STREET_OR_ADDRESS_LINE_1_FIELD_NAME_NORMALIZED = 'SwissQR.DebtorStreetOrAddressLine1';
SwissQR.DUE_DATE_FIELD_NAME = 'DueDate';
SwissQR.DUE_DATE_FIELD_NAME_NORMALIZED = 'SwissQR.DueDate';
SwissQR.ENCODING_FIELD_NAME = 'Encoding';
SwissQR.ENCODING_FIELD_NAME_NORMALIZED = 'SwissQR.Encoding';
SwissQR.FINAL_PAYEE_ADDRESS_TYPE_FIELD_NAME = 'FinalPayeeAddressType';
SwissQR.FINAL_PAYEE_ADDRESS_TYPE_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeeAddressType';
SwissQR.FINAL_PAYEE_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME = 'FinalPayeeBuildingOrAddressLine2';
SwissQR.FINAL_PAYEE_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeeBuildingOrAddressLine2';
SwissQR.FINAL_PAYEE_COUNTRY_FIELD_NAME = 'FinalPayeeCountry';
SwissQR.FINAL_PAYEE_COUNTRY_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeeCountry';
SwissQR.FINAL_PAYEE_NAME_FIELD_NAME = 'FinalPayeeName';
SwissQR.FINAL_PAYEE_NAME_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeeName';
SwissQR.FINAL_PAYEE_PLACE_FIELD_NAME = 'FinalPayeePlace';
SwissQR.FINAL_PAYEE_PLACE_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeePlace';
SwissQR.FINAL_PAYEE_POSTAL_CODE_FIELD_NAME = 'FinalPayeePostalCode';
SwissQR.FINAL_PAYEE_POSTAL_CODE_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeePostalCode';
SwissQR.FINAL_PAYEE_STREET_OR_ADDRESS_LINE_1_FIELD_NAME = 'FinalPayeeStreetOrAddressLine1';
SwissQR.FINAL_PAYEE_STREET_OR_ADDRESS_LINE_1_FIELD_NAME_NORMALIZED = 'SwissQR.FinalPayeeStreetOrAddressLine1';
SwissQR.IBAN_FIELD_NAME = 'IBAN';
SwissQR.IBAN_FIELD_NAME_NORMALIZED = 'SwissQR.IBAN';
SwissQR.MAJOR_VERSION_FIELD_NAME = 'MajorVersion';
SwissQR.MAJOR_VERSION_FIELD_NAME_NORMALIZED = 'SwissQR.MajorVersion';
SwissQR.PAYEE_ADDRESS_TYPE_FIELD_NAME = 'PayeeAddressType';
SwissQR.PAYEE_ADDRESS_TYPE_FIELD_NAME_NORMALIZED = 'SwissQR.PayeeAddressType';
SwissQR.PAYEE_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME = 'PayeeBuildingOrAddressLine2';
SwissQR.PAYEE_BUILDING_OR_ADDRESS_LINE_2_FIELD_NAME_NORMALIZED = 'SwissQR.PayeeBuildingOrAddressLine2';
SwissQR.PAYEE_COUNTRY_FIELD_NAME = 'PayeeCountry';
SwissQR.PAYEE_COUNTRY_FIELD_NAME_NORMALIZED = 'SwissQR.PayeeCountry';
SwissQR.PAYEE_NAME_FIELD_NAME = 'PayeeName';
SwissQR.PAYEE_NAME_FIELD_NAME_NORMALIZED = 'SwissQR.PayeeName';
SwissQR.PAYEE_PLACE_FIELD_NAME = 'PayeePlace';
SwissQR.PAYEE_PLACE_FIELD_NAME_NORMALIZED = 'SwissQR.PayeePlace';
SwissQR.PAYEE_POSTAL_CODE_FIELD_NAME = 'PayeePostalCode';
SwissQR.PAYEE_POSTAL_CODE_FIELD_NAME_NORMALIZED = 'SwissQR.PayeePostalCode';
SwissQR.PAYEE_STREET_OR_ADDRESS_LINE_1_FIELD_NAME = 'PayeeStreetOrAddressLine1';
SwissQR.PAYEE_STREET_OR_ADDRESS_LINE_1_FIELD_NAME_NORMALIZED = 'SwissQR.PayeeStreetOrAddressLine1';
SwissQR.PAYMENT_REFERENCE_FIELD_NAME = 'PaymentReference';
SwissQR.PAYMENT_REFERENCE_FIELD_NAME_NORMALIZED = 'SwissQR.PaymentReference';
SwissQR.PAYMENT_REFERENCE_TYPE_FIELD_NAME = 'PaymentReferenceType';
SwissQR.PAYMENT_REFERENCE_TYPE_FIELD_NAME_NORMALIZED = 'SwissQR.PaymentReferenceType';
/** Medical Plan */
export class DEMedicalPlan {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DEMedicalPlan.DOCUMENT_TYPE;
    }
    /** Current Page */
    get currentPage() {
        return this.document.fields.find((f) => f.type.name === 'CurrentPage');
    }
    /** Document Version Number */
    get documentVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'DocumentVersionNumber');
    }
    /** GUID */
    get guid() {
        return this.document.fields.find((f) => f.type.name === 'GUID');
    }
    /** Language Country Code */
    get languageCountryCode() {
        return this.document.fields.find((f) => f.type.name === 'LanguageCountryCode');
    }
    /** Patch Version Number */
    get patchVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'PatchVersionNumber');
    }
    /** Total Number Of Pages */
    get totalNumberOfPages() {
        return this.document.fields.find((f) => f.type.name === 'TotalNumberOfPages');
    }
    /** The child document of type "Patient". */
    get patient() {
        const child = this.document.children.find((c) => c.type.name === 'Patient');
        return new DEMedicalPlan.Patient(child);
    }
    /** The child document of type "Doctor". */
    get doctor() {
        const child = this.document.children.find((c) => c.type.name === 'Doctor');
        return new DEMedicalPlan.Doctor(child);
    }
    /** An array of all children of type "Subheading". */
    get subheadings() {
        return this.document.children
            .filter((c) => c.type.name === 'Subheading')
            .map((c) => new DEMedicalPlan.Subheading(c));
    }
}
DEMedicalPlan.DOCUMENT_TYPE = 'DEMedicalPlan';
DEMedicalPlan.CURRENT_PAGE_FIELD_NAME = 'CurrentPage';
DEMedicalPlan.CURRENT_PAGE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.CurrentPage';
DEMedicalPlan.DOCUMENT_VERSION_NUMBER_FIELD_NAME = 'DocumentVersionNumber';
DEMedicalPlan.DOCUMENT_VERSION_NUMBER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.DocumentVersionNumber';
DEMedicalPlan.GUID_FIELD_NAME = 'GUID';
DEMedicalPlan.GUID_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.GUID';
DEMedicalPlan.LANGUAGE_COUNTRY_CODE_FIELD_NAME = 'LanguageCountryCode';
DEMedicalPlan.LANGUAGE_COUNTRY_CODE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.LanguageCountryCode';
DEMedicalPlan.PATCH_VERSION_NUMBER_FIELD_NAME = 'PatchVersionNumber';
DEMedicalPlan.PATCH_VERSION_NUMBER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.PatchVersionNumber';
DEMedicalPlan.TOTAL_NUMBER_OF_PAGES_FIELD_NAME = 'TotalNumberOfPages';
DEMedicalPlan.TOTAL_NUMBER_OF_PAGES_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.TotalNumberOfPages';
(function (DEMedicalPlan) {
    /** Patient */
    class Patient {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlan.Patient.DOCUMENT_TYPE;
        }
        /** Allergies And Intolerances */
        get allergiesAndIntolerances() {
            return this.document.fields.find((f) => f.type.name === 'AllergiesAndIntolerances');
        }
        /** Birth Date */
        get birthDate() {
            return this.document.fields.find((f) => f.type.name === 'BirthDate');
        }
        /** Breast Feeding */
        get breastFeeding() {
            return this.document.fields.find((f) => f.type.name === 'BreastFeeding');
        }
        /** Creatinine Value */
        get creatinineValue() {
            return this.document.fields.find((f) => f.type.name === 'CreatinineValue');
        }
        /** First Name */
        get firstName() {
            return this.document.fields.find((f) => f.type.name === 'FirstName');
        }
        /** Gender */
        get gender() {
            return this.document.fields.find((f) => f.type.name === 'Gender');
        }
        /** Height */
        get height() {
            return this.document.fields.find((f) => f.type.name === 'Height');
        }
        /** Last Name */
        get lastName() {
            return this.document.fields.find((f) => f.type.name === 'LastName');
        }
        /** Patient Free Text */
        get patientFreeText() {
            return this.document.fields.find((f) => f.type.name === 'PatientFreeText');
        }
        /** Patient ID */
        get patientID() {
            return this.document.fields.find((f) => f.type.name === 'PatientID');
        }
        /** Pre Name */
        get preName() {
            return this.document.fields.find((f) => f.type.name === 'PreName');
        }
        /** Pregnant */
        get pregnant() {
            return this.document.fields.find((f) => f.type.name === 'Pregnant');
        }
        /** Name Suffix */
        get suffix() {
            return this.document.fields.find((f) => f.type.name === 'Suffix');
        }
        /** Title */
        get title() {
            return this.document.fields.find((f) => f.type.name === 'Title');
        }
        /** Weight */
        get weight() {
            return this.document.fields.find((f) => f.type.name === 'Weight');
        }
    }
    Patient.DOCUMENT_TYPE = 'Patient';
    Patient.ALLERGIES_AND_INTOLERANCES_FIELD_NAME = 'AllergiesAndIntolerances';
    Patient.ALLERGIES_AND_INTOLERANCES_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.AllergiesAndIntolerances';
    Patient.BIRTH_DATE_FIELD_NAME = 'BirthDate';
    Patient.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.BirthDate';
    Patient.BREAST_FEEDING_FIELD_NAME = 'BreastFeeding';
    Patient.BREAST_FEEDING_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.BreastFeeding';
    Patient.CREATININE_VALUE_FIELD_NAME = 'CreatinineValue';
    Patient.CREATININE_VALUE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.CreatinineValue';
    Patient.FIRST_NAME_FIELD_NAME = 'FirstName';
    Patient.FIRST_NAME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.FirstName';
    Patient.GENDER_FIELD_NAME = 'Gender';
    Patient.GENDER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Gender';
    Patient.HEIGHT_FIELD_NAME = 'Height';
    Patient.HEIGHT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Height';
    Patient.LAST_NAME_FIELD_NAME = 'LastName';
    Patient.LAST_NAME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.LastName';
    Patient.PATIENT_FREE_TEXT_FIELD_NAME = 'PatientFreeText';
    Patient.PATIENT_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.PatientFreeText';
    Patient.PATIENT_ID_FIELD_NAME = 'PatientID';
    Patient.PATIENT_ID_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.PatientID';
    Patient.PRE_NAME_FIELD_NAME = 'PreName';
    Patient.PRE_NAME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.PreName';
    Patient.PREGNANT_FIELD_NAME = 'Pregnant';
    Patient.PREGNANT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Pregnant';
    Patient.SUFFIX_FIELD_NAME = 'Suffix';
    Patient.SUFFIX_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Suffix';
    Patient.TITLE_FIELD_NAME = 'Title';
    Patient.TITLE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Title';
    Patient.WEIGHT_FIELD_NAME = 'Weight';
    Patient.WEIGHT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Patient.Weight';
    DEMedicalPlan.Patient = Patient;
    /** Doctor */
    class Doctor {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlan.Doctor.DOCUMENT_TYPE;
        }
        /** Doctor Number */
        get doctorNumber() {
            return this.document.fields.find((f) => f.type.name === 'DoctorNumber');
        }
        /** Email */
        get email() {
            return this.document.fields.find((f) => f.type.name === 'Email');
        }
        /** Hospital ID */
        get hospitalID() {
            return this.document.fields.find((f) => f.type.name === 'HospitalID');
        }
        /** Issuer Name */
        get issuerName() {
            return this.document.fields.find((f) => f.type.name === 'IssuerName');
        }
        /** Issuing Date And Time */
        get issuingDateAndTime() {
            return this.document.fields.find((f) => f.type.name === 'IssuingDateAndTime');
        }
        /** Pharmacy ID */
        get pharmacyID() {
            return this.document.fields.find((f) => f.type.name === 'PharmacyID');
        }
        /** Place */
        get place() {
            return this.document.fields.find((f) => f.type.name === 'Place');
        }
        /** Postal Code */
        get postalCode() {
            return this.document.fields.find((f) => f.type.name === 'PostalCode');
        }
        /** Street */
        get street() {
            return this.document.fields.find((f) => f.type.name === 'Street');
        }
        /** Telephone Number */
        get telephoneNumber() {
            return this.document.fields.find((f) => f.type.name === 'TelephoneNumber');
        }
    }
    Doctor.DOCUMENT_TYPE = 'Doctor';
    Doctor.DOCTOR_NUMBER_FIELD_NAME = 'DoctorNumber';
    Doctor.DOCTOR_NUMBER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.DoctorNumber';
    Doctor.EMAIL_FIELD_NAME = 'Email';
    Doctor.EMAIL_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.Email';
    Doctor.HOSPITAL_ID_FIELD_NAME = 'HospitalID';
    Doctor.HOSPITAL_ID_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.HospitalID';
    Doctor.ISSUER_NAME_FIELD_NAME = 'IssuerName';
    Doctor.ISSUER_NAME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.IssuerName';
    Doctor.ISSUING_DATE_AND_TIME_FIELD_NAME = 'IssuingDateAndTime';
    Doctor.ISSUING_DATE_AND_TIME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.IssuingDateAndTime';
    Doctor.PHARMACY_ID_FIELD_NAME = 'PharmacyID';
    Doctor.PHARMACY_ID_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.PharmacyID';
    Doctor.PLACE_FIELD_NAME = 'Place';
    Doctor.PLACE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.Place';
    Doctor.POSTAL_CODE_FIELD_NAME = 'PostalCode';
    Doctor.POSTAL_CODE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.PostalCode';
    Doctor.STREET_FIELD_NAME = 'Street';
    Doctor.STREET_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.Street';
    Doctor.TELEPHONE_NUMBER_FIELD_NAME = 'TelephoneNumber';
    Doctor.TELEPHONE_NUMBER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Doctor.TelephoneNumber';
    DEMedicalPlan.Doctor = Doctor;
    /** Subheading */
    class Subheading {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DEMedicalPlan.Subheading.DOCUMENT_TYPE;
        }
        /** General Note */
        get generalNotes() {
            return this.document.fields.filter((f) => f.type.name === 'GeneralNote');
        }
        /** Key Words */
        get keyWords() {
            return this.document.fields.find((f) => f.type.name === 'KeyWords');
        }
        /** Subheading Free Text */
        get subheadingFreeText() {
            return this.document.fields.find((f) => f.type.name === 'SubheadingFreeText');
        }
        /** An array of all children of type "Medicine". */
        get medicines() {
            return this.document.children
                .filter((c) => c.type.name === 'Medicine')
                .map((c) => new DEMedicalPlan.Subheading.Medicine(c));
        }
        /** An array of all children of type "Prescription". */
        get prescriptions() {
            return this.document.children
                .filter((c) => c.type.name === 'Prescription')
                .map((c) => new DEMedicalPlan.Subheading.Prescription(c));
        }
    }
    Subheading.DOCUMENT_TYPE = 'Subheading';
    Subheading.GENERAL_NOTE_FIELD_NAME = 'GeneralNote';
    Subheading.GENERAL_NOTE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.GeneralNote';
    Subheading.KEY_WORDS_FIELD_NAME = 'KeyWords';
    Subheading.KEY_WORDS_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.KeyWords';
    Subheading.SUBHEADING_FREE_TEXT_FIELD_NAME = 'SubheadingFreeText';
    Subheading.SUBHEADING_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.SubheadingFreeText';
    DEMedicalPlan.Subheading = Subheading;
    (function (Subheading) {
        /** Medicine */
        class Medicine {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return DEMedicalPlan.Subheading.Medicine.DOCUMENT_TYPE;
            }
            /** Dosage Form */
            get dosageForm() {
                return this.document.fields.find((f) => f.type.name === 'DosageForm');
            }
            /** Dosage Form Free Text */
            get dosageFormFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosageFormFreeText');
            }
            /** Dosage Free Text */
            get dosageFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosageFreeText');
            }
            /** Dosing Unit */
            get dosingUnit() {
                return this.document.fields.find((f) => f.type.name === 'DosingUnit');
            }
            /** Dosing Unit Free Text */
            get dosingUnitFreeText() {
                return this.document.fields.find((f) => f.type.name === 'DosingUnitFreeText');
            }
            /** Drug Name */
            get drugName() {
                return this.document.fields.find((f) => f.type.name === 'DrugName');
            }
            /** Evening Intake Dose */
            get evening() {
                return this.document.fields.find((f) => f.type.name === 'Evening');
            }
            /** General Notes */
            get generalNotes() {
                return this.document.fields.find((f) => f.type.name === 'GeneralNotes');
            }
            /** Midday Intake Dose */
            get midday() {
                return this.document.fields.find((f) => f.type.name === 'Midday');
            }
            /** Morning Intake Dose */
            get morning() {
                return this.document.fields.find((f) => f.type.name === 'Morning');
            }
            /** Night Intake Dose */
            get night() {
                return this.document.fields.find((f) => f.type.name === 'Night');
            }
            /** Pharmaceutical Number */
            get pharmaceuticalNumber() {
                return this.document.fields.find((f) => f.type.name === 'PharmaceuticalNumber');
            }
            /** Reason For Treatment */
            get reasonForTreatment() {
                return this.document.fields.find((f) => f.type.name === 'ReasonForTreatment');
            }
            /** Relevant Info */
            get relevantInfo() {
                return this.document.fields.find((f) => f.type.name === 'RelevantInfo');
            }
            /** An array of all children of type "Substance". */
            get substances() {
                return this.document.children
                    .filter((c) => c.type.name === 'Substance')
                    .map((c) => new DEMedicalPlan.Subheading.Medicine.Substance(c));
            }
        }
        Medicine.DOCUMENT_TYPE = 'Medicine';
        Medicine.DOSAGE_FORM_FIELD_NAME = 'DosageForm';
        Medicine.DOSAGE_FORM_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DosageForm';
        Medicine.DOSAGE_FORM_FREE_TEXT_FIELD_NAME = 'DosageFormFreeText';
        Medicine.DOSAGE_FORM_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DosageFormFreeText';
        Medicine.DOSAGE_FREE_TEXT_FIELD_NAME = 'DosageFreeText';
        Medicine.DOSAGE_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DosageFreeText';
        Medicine.DOSING_UNIT_FIELD_NAME = 'DosingUnit';
        Medicine.DOSING_UNIT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DosingUnit';
        Medicine.DOSING_UNIT_FREE_TEXT_FIELD_NAME = 'DosingUnitFreeText';
        Medicine.DOSING_UNIT_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DosingUnitFreeText';
        Medicine.DRUG_NAME_FIELD_NAME = 'DrugName';
        Medicine.DRUG_NAME_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.DrugName';
        Medicine.EVENING_FIELD_NAME = 'Evening';
        Medicine.EVENING_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Evening';
        Medicine.GENERAL_NOTES_FIELD_NAME = 'GeneralNotes';
        Medicine.GENERAL_NOTES_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.GeneralNotes';
        Medicine.MIDDAY_FIELD_NAME = 'Midday';
        Medicine.MIDDAY_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Midday';
        Medicine.MORNING_FIELD_NAME = 'Morning';
        Medicine.MORNING_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Morning';
        Medicine.NIGHT_FIELD_NAME = 'Night';
        Medicine.NIGHT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Night';
        Medicine.PHARMACEUTICAL_NUMBER_FIELD_NAME = 'PharmaceuticalNumber';
        Medicine.PHARMACEUTICAL_NUMBER_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.PharmaceuticalNumber';
        Medicine.REASON_FOR_TREATMENT_FIELD_NAME = 'ReasonForTreatment';
        Medicine.REASON_FOR_TREATMENT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.ReasonForTreatment';
        Medicine.RELEVANT_INFO_FIELD_NAME = 'RelevantInfo';
        Medicine.RELEVANT_INFO_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.RelevantInfo';
        Subheading.Medicine = Medicine;
        (function (Medicine) {
            /** Substance */
            class Substance {
                get document() {
                    return this._document;
                }
                constructor(document) {
                    if (document.type.name !== this.requiredDocumentType()) {
                        throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                    }
                    this._document = document;
                }
                requiredDocumentType() {
                    return DEMedicalPlan.Subheading.Medicine.Substance.DOCUMENT_TYPE;
                }
                /** Active Substance */
                get activeSubstance() {
                    return this.document.fields.find((f) => f.type.name === 'ActiveSubstance');
                }
                /** Potency */
                get potency() {
                    return this.document.fields.find((f) => f.type.name === 'Potency');
                }
            }
            Substance.DOCUMENT_TYPE = 'Substance';
            Substance.ACTIVE_SUBSTANCE_FIELD_NAME = 'ActiveSubstance';
            Substance.ACTIVE_SUBSTANCE_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Substance.ActiveSubstance';
            Substance.POTENCY_FIELD_NAME = 'Potency';
            Substance.POTENCY_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Medicine.Substance.Potency';
            Medicine.Substance = Substance;
        })(Medicine = Subheading.Medicine || (Subheading.Medicine = {}));
        /** Prescription */
        class Prescription {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return DEMedicalPlan.Subheading.Prescription.DOCUMENT_TYPE;
            }
            /** General Information */
            get generalInformation() {
                return this.document.fields.find((f) => f.type.name === 'GeneralInformation');
            }
            /** Prescription Free Text */
            get prescriptionFreeText() {
                return this.document.fields.find((f) => f.type.name === 'PrescriptionFreeText');
            }
        }
        Prescription.DOCUMENT_TYPE = 'Prescription';
        Prescription.GENERAL_INFORMATION_FIELD_NAME = 'GeneralInformation';
        Prescription.GENERAL_INFORMATION_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Prescription.GeneralInformation';
        Prescription.PRESCRIPTION_FREE_TEXT_FIELD_NAME = 'PrescriptionFreeText';
        Prescription.PRESCRIPTION_FREE_TEXT_FIELD_NAME_NORMALIZED = 'DEMedicalPlan.Subheading.Prescription.PrescriptionFreeText';
        Subheading.Prescription = Prescription;
    })(Subheading = DEMedicalPlan.Subheading || (DEMedicalPlan.Subheading = {}));
})(DEMedicalPlan || (DEMedicalPlan = {}));
/** ID Card */
export class IDCardPDF417 {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return IDCardPDF417.DOCUMENT_TYPE;
    }
    /** Birth Date. The format is ISO8601 with delimiters */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Date Expired. The format is ISO8601 with delimiters */
    get dateExpired() {
        return this.document.fields.find((f) => f.type.name === 'DateExpired');
    }
    /** Date Issued. The format is ISO8601 with delimiters */
    get dateIssued() {
        return this.document.fields.find((f) => f.type.name === 'DateIssued');
    }
    /** Document Code */
    get documentCode() {
        return this.document.fields.find((f) => f.type.name === 'DocumentCode');
    }
    /** First Name */
    get firstName() {
        return this.document.fields.find((f) => f.type.name === 'FirstName');
    }
    /** Last Name */
    get lastName() {
        return this.document.fields.find((f) => f.type.name === 'LastName');
    }
    /** Optional */
    get optional() {
        return this.document.fields.find((f) => f.type.name === 'Optional');
    }
}
IDCardPDF417.DOCUMENT_TYPE = 'IDCardPDF417';
IDCardPDF417.BIRTH_DATE_FIELD_NAME = 'BirthDate';
IDCardPDF417.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'IDCardPDF417.BirthDate';
IDCardPDF417.DATE_EXPIRED_FIELD_NAME = 'DateExpired';
IDCardPDF417.DATE_EXPIRED_FIELD_NAME_NORMALIZED = 'IDCardPDF417.DateExpired';
IDCardPDF417.DATE_ISSUED_FIELD_NAME = 'DateIssued';
IDCardPDF417.DATE_ISSUED_FIELD_NAME_NORMALIZED = 'IDCardPDF417.DateIssued';
IDCardPDF417.DOCUMENT_CODE_FIELD_NAME = 'DocumentCode';
IDCardPDF417.DOCUMENT_CODE_FIELD_NAME_NORMALIZED = 'IDCardPDF417.DocumentCode';
IDCardPDF417.FIRST_NAME_FIELD_NAME = 'FirstName';
IDCardPDF417.FIRST_NAME_FIELD_NAME_NORMALIZED = 'IDCardPDF417.FirstName';
IDCardPDF417.LAST_NAME_FIELD_NAME = 'LastName';
IDCardPDF417.LAST_NAME_FIELD_NAME_NORMALIZED = 'IDCardPDF417.LastName';
IDCardPDF417.OPTIONAL_FIELD_NAME = 'Optional';
IDCardPDF417.OPTIONAL_FIELD_NAME_NORMALIZED = 'IDCardPDF417.Optional';
/** GS1 */
export class GS1 {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return GS1.DOCUMENT_TYPE;
    }
    /** An array of all children of type "Element". */
    get elements() {
        return this.document.children
            .filter((c) => c.type.name === 'Element')
            .map((c) => new GS1.Element(c));
    }
}
GS1.DOCUMENT_TYPE = 'GS1';
(function (GS1) {
    /** GS1 Element */
    class Element {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return GS1.Element.DOCUMENT_TYPE;
        }
        /** Application Identifier */
        get applicationIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'ApplicationIdentifier');
        }
        /** Data Title */
        get dataTitle() {
            return this.document.fields.find((f) => f.type.name === 'DataTitle');
        }
        /** Description */
        get elementDescription() {
            return this.document.fields.find((f) => f.type.name === 'ElementDescription');
        }
        /** Raw Value */
        get rawValue() {
            return this.document.fields.find((f) => f.type.name === 'RawValue');
        }
        /** An array of all children of type "ValidationError". */
        get validationErrors() {
            return this.document.children
                .filter((c) => c.type.name === 'ValidationError')
                .map((c) => new GS1.Element.ValidationError(c));
        }
    }
    Element.DOCUMENT_TYPE = 'Element';
    Element.APPLICATION_IDENTIFIER_FIELD_NAME = 'ApplicationIdentifier';
    Element.APPLICATION_IDENTIFIER_FIELD_NAME_NORMALIZED = 'GS1.Element.ApplicationIdentifier';
    Element.DATA_TITLE_FIELD_NAME = 'DataTitle';
    Element.DATA_TITLE_FIELD_NAME_NORMALIZED = 'GS1.Element.DataTitle';
    Element.ELEMENT_DESCRIPTION_FIELD_NAME = 'ElementDescription';
    Element.ELEMENT_DESCRIPTION_FIELD_NAME_NORMALIZED = 'GS1.Element.ElementDescription';
    Element.RAW_VALUE_FIELD_NAME = 'RawValue';
    Element.RAW_VALUE_FIELD_NAME_NORMALIZED = 'GS1.Element.RawValue';
    GS1.Element = Element;
    (function (Element) {
        /** Validation Errors */
        class ValidationError {
            get document() {
                return this._document;
            }
            constructor(document) {
                if (document.type.name !== this.requiredDocumentType()) {
                    throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
                }
                this._document = document;
            }
            requiredDocumentType() {
                return GS1.Element.ValidationError.DOCUMENT_TYPE;
            }
            /** Error Code */
            get code() {
                return this.document.fields.find((f) => f.type.name === 'Code');
            }
            /** Reason */
            get reason() {
                return this.document.fields.find((f) => f.type.name === 'Reason');
            }
        }
        ValidationError.DOCUMENT_TYPE = 'ValidationError';
        ValidationError.CODE_FIELD_NAME = 'Code';
        ValidationError.CODE_FIELD_NAME_NORMALIZED = 'GS1.Element.ValidationError.Code';
        ValidationError.REASON_FIELD_NAME = 'Reason';
        ValidationError.REASON_FIELD_NAME_NORMALIZED = 'GS1.Element.ValidationError.Reason';
        Element.ValidationError = ValidationError;
    })(Element = GS1.Element || (GS1.Element = {}));
})(GS1 || (GS1 = {}));
/** SEPA */
export class SEPA {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return SEPA.DOCUMENT_TYPE;
    }
    /** Amount */
    get amount() {
        return this.document.fields.find((f) => f.type.name === 'Amount');
    }
    /** Character Set */
    get characterSet() {
        return this.document.fields.find((f) => f.type.name === 'CharacterSet');
    }
    /** Identification */
    get identification() {
        return this.document.fields.find((f) => f.type.name === 'Identification');
    }
    /** Information */
    get information() {
        return this.document.fields.find((f) => f.type.name === 'Information');
    }
    /** Amount */
    get purpose() {
        return this.document.fields.find((f) => f.type.name === 'Purpose');
    }
    /** Receiver BIC */
    get receiverBIC() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverBIC');
    }
    /** Receiver IBAN */
    get receiverIBAN() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverIBAN');
    }
    /** Receiver Name */
    get receiverName() {
        return this.document.fields.find((f) => f.type.name === 'ReceiverName');
    }
    /** Remittance */
    get remittance() {
        return this.document.fields.find((f) => f.type.name === 'Remittance');
    }
    /** Service Tag */
    get serviceTag() {
        return this.document.fields.find((f) => f.type.name === 'ServiceTag');
    }
    /** Version */
    get version() {
        return this.document.fields.find((f) => f.type.name === 'Version');
    }
}
SEPA.DOCUMENT_TYPE = 'SEPA';
SEPA.AMOUNT_FIELD_NAME = 'Amount';
SEPA.AMOUNT_FIELD_NAME_NORMALIZED = 'SEPA.Amount';
SEPA.CHARACTER_SET_FIELD_NAME = 'CharacterSet';
SEPA.CHARACTER_SET_FIELD_NAME_NORMALIZED = 'SEPA.CharacterSet';
SEPA.IDENTIFICATION_FIELD_NAME = 'Identification';
SEPA.IDENTIFICATION_FIELD_NAME_NORMALIZED = 'SEPA.Identification';
SEPA.INFORMATION_FIELD_NAME = 'Information';
SEPA.INFORMATION_FIELD_NAME_NORMALIZED = 'SEPA.Information';
SEPA.PURPOSE_FIELD_NAME = 'Purpose';
SEPA.PURPOSE_FIELD_NAME_NORMALIZED = 'SEPA.Purpose';
SEPA.RECEIVER_BIC_FIELD_NAME = 'ReceiverBIC';
SEPA.RECEIVER_BIC_FIELD_NAME_NORMALIZED = 'SEPA.ReceiverBIC';
SEPA.RECEIVER_IBAN_FIELD_NAME = 'ReceiverIBAN';
SEPA.RECEIVER_IBAN_FIELD_NAME_NORMALIZED = 'SEPA.ReceiverIBAN';
SEPA.RECEIVER_NAME_FIELD_NAME = 'ReceiverName';
SEPA.RECEIVER_NAME_FIELD_NAME_NORMALIZED = 'SEPA.ReceiverName';
SEPA.REMITTANCE_FIELD_NAME = 'Remittance';
SEPA.REMITTANCE_FIELD_NAME_NORMALIZED = 'SEPA.Remittance';
SEPA.SERVICE_TAG_FIELD_NAME = 'ServiceTag';
SEPA.SERVICE_TAG_FIELD_NAME_NORMALIZED = 'SEPA.ServiceTag';
SEPA.VERSION_FIELD_NAME = 'Version';
SEPA.VERSION_FIELD_NAME_NORMALIZED = 'SEPA.Version';
/** Medical Certificate */
export class MedicalCertificate {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MedicalCertificate.DOCUMENT_TYPE;
    }
    /** Accident */
    get accident() {
        return this.document.fields.find((f) => f.type.name === 'Accident');
    }
    /** Assigned To Accident Insurance Doctor */
    get assignedToAccidentInsuranceDoctor() {
        return this.document.fields.find((f) => f.type.name === 'AssignedToAccidentInsuranceDoctor');
    }
    /** Birth Date. The format is ISO8601 with delimiters */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Child Needs Care From */
    get childNeedsCareFrom() {
        return this.document.fields.find((f) => f.type.name === 'ChildNeedsCareFrom');
    }
    /** Child Needs Care Until */
    get childNeedsCareUntil() {
        return this.document.fields.find((f) => f.type.name === 'ChildNeedsCareUntil');
    }
    /** Diagnose */
    get diagnose() {
        return this.document.fields.find((f) => f.type.name === 'Diagnose');
    }
    /** Diagnosed On. The format is ISO8601 with delimiters */
    get diagnosedOn() {
        return this.document.fields.find((f) => f.type.name === 'DiagnosedOn');
    }
    /** Doctor Number */
    get doctorNumber() {
        return this.document.fields.find((f) => f.type.name === 'DoctorNumber');
    }
    /** Document Date. The format is ISO8601 with delimiters */
    get documentDate() {
        return this.document.fields.find((f) => f.type.name === 'DocumentDate');
    }
    /** First Name */
    get firstName() {
        return this.document.fields.find((f) => f.type.name === 'FirstName');
    }
    /** Health Insurance Number */
    get healthInsuranceNumber() {
        return this.document.fields.find((f) => f.type.name === 'HealthInsuranceNumber');
    }
    /** Incapable Of Work Since. The format is ISO8601 with delimiters */
    get incapableOfWorkSince() {
        return this.document.fields.find((f) => f.type.name === 'IncapableOfWorkSince');
    }
    /** Incapable Of Work Until. The format is ISO8601 with delimiters */
    get incapableOfWorkUntil() {
        return this.document.fields.find((f) => f.type.name === 'IncapableOfWorkUntil');
    }
    /** Initial Certificate */
    get initialCertificate() {
        return this.document.fields.find((f) => f.type.name === 'InitialCertificate');
    }
    /** Insured Person Number */
    get insuredPersonNumber() {
        return this.document.fields.find((f) => f.type.name === 'InsuredPersonNumber');
    }
    /** Last Name */
    get lastName() {
        return this.document.fields.find((f) => f.type.name === 'LastName');
    }
    /** Place Of Operation Number */
    get placeOfOperationNumber() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfOperationNumber');
    }
    /** Renewed Certificate */
    get renewedCertificate() {
        return this.document.fields.find((f) => f.type.name === 'RenewedCertificate');
    }
    /** Requires Care */
    get requiresCare() {
        return this.document.fields.find((f) => f.type.name === 'RequiresCare');
    }
    /** Status */
    get status() {
        return this.document.fields.find((f) => f.type.name === 'Status');
    }
    /** Work Accident */
    get workAccident() {
        return this.document.fields.find((f) => f.type.name === 'WorkAccident');
    }
}
MedicalCertificate.DOCUMENT_TYPE = 'MedicalCertificate';
MedicalCertificate.ACCIDENT_FIELD_NAME = 'Accident';
MedicalCertificate.ACCIDENT_FIELD_NAME_NORMALIZED = 'MedicalCertificate.Accident';
MedicalCertificate.ASSIGNED_TO_ACCIDENT_INSURANCE_DOCTOR_FIELD_NAME = 'AssignedToAccidentInsuranceDoctor';
MedicalCertificate.ASSIGNED_TO_ACCIDENT_INSURANCE_DOCTOR_FIELD_NAME_NORMALIZED = 'MedicalCertificate.AssignedToAccidentInsuranceDoctor';
MedicalCertificate.BIRTH_DATE_FIELD_NAME = 'BirthDate';
MedicalCertificate.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.BirthDate';
MedicalCertificate.CHILD_NEEDS_CARE_FROM_FIELD_NAME = 'ChildNeedsCareFrom';
MedicalCertificate.CHILD_NEEDS_CARE_FROM_FIELD_NAME_NORMALIZED = 'MedicalCertificate.ChildNeedsCareFrom';
MedicalCertificate.CHILD_NEEDS_CARE_UNTIL_FIELD_NAME = 'ChildNeedsCareUntil';
MedicalCertificate.CHILD_NEEDS_CARE_UNTIL_FIELD_NAME_NORMALIZED = 'MedicalCertificate.ChildNeedsCareUntil';
MedicalCertificate.DIAGNOSE_FIELD_NAME = 'Diagnose';
MedicalCertificate.DIAGNOSE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.Diagnose';
MedicalCertificate.DIAGNOSED_ON_FIELD_NAME = 'DiagnosedOn';
MedicalCertificate.DIAGNOSED_ON_FIELD_NAME_NORMALIZED = 'MedicalCertificate.DiagnosedOn';
MedicalCertificate.DOCTOR_NUMBER_FIELD_NAME = 'DoctorNumber';
MedicalCertificate.DOCTOR_NUMBER_FIELD_NAME_NORMALIZED = 'MedicalCertificate.DoctorNumber';
MedicalCertificate.DOCUMENT_DATE_FIELD_NAME = 'DocumentDate';
MedicalCertificate.DOCUMENT_DATE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.DocumentDate';
MedicalCertificate.FIRST_NAME_FIELD_NAME = 'FirstName';
MedicalCertificate.FIRST_NAME_FIELD_NAME_NORMALIZED = 'MedicalCertificate.FirstName';
MedicalCertificate.HEALTH_INSURANCE_NUMBER_FIELD_NAME = 'HealthInsuranceNumber';
MedicalCertificate.HEALTH_INSURANCE_NUMBER_FIELD_NAME_NORMALIZED = 'MedicalCertificate.HealthInsuranceNumber';
MedicalCertificate.INCAPABLE_OF_WORK_SINCE_FIELD_NAME = 'IncapableOfWorkSince';
MedicalCertificate.INCAPABLE_OF_WORK_SINCE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.IncapableOfWorkSince';
MedicalCertificate.INCAPABLE_OF_WORK_UNTIL_FIELD_NAME = 'IncapableOfWorkUntil';
MedicalCertificate.INCAPABLE_OF_WORK_UNTIL_FIELD_NAME_NORMALIZED = 'MedicalCertificate.IncapableOfWorkUntil';
MedicalCertificate.INITIAL_CERTIFICATE_FIELD_NAME = 'InitialCertificate';
MedicalCertificate.INITIAL_CERTIFICATE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.InitialCertificate';
MedicalCertificate.INSURED_PERSON_NUMBER_FIELD_NAME = 'InsuredPersonNumber';
MedicalCertificate.INSURED_PERSON_NUMBER_FIELD_NAME_NORMALIZED = 'MedicalCertificate.InsuredPersonNumber';
MedicalCertificate.LAST_NAME_FIELD_NAME = 'LastName';
MedicalCertificate.LAST_NAME_FIELD_NAME_NORMALIZED = 'MedicalCertificate.LastName';
MedicalCertificate.PLACE_OF_OPERATION_NUMBER_FIELD_NAME = 'PlaceOfOperationNumber';
MedicalCertificate.PLACE_OF_OPERATION_NUMBER_FIELD_NAME_NORMALIZED = 'MedicalCertificate.PlaceOfOperationNumber';
MedicalCertificate.RENEWED_CERTIFICATE_FIELD_NAME = 'RenewedCertificate';
MedicalCertificate.RENEWED_CERTIFICATE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.RenewedCertificate';
MedicalCertificate.REQUIRES_CARE_FIELD_NAME = 'RequiresCare';
MedicalCertificate.REQUIRES_CARE_FIELD_NAME_NORMALIZED = 'MedicalCertificate.RequiresCare';
MedicalCertificate.STATUS_FIELD_NAME = 'Status';
MedicalCertificate.STATUS_FIELD_NAME_NORMALIZED = 'MedicalCertificate.Status';
MedicalCertificate.WORK_ACCIDENT_FIELD_NAME = 'WorkAccident';
MedicalCertificate.WORK_ACCIDENT_FIELD_NAME_NORMALIZED = 'MedicalCertificate.WorkAccident';
/** VCard */
export class VCard {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return VCard.DOCUMENT_TYPE;
    }
    /** The child document of type "Version". */
    get version() {
        const child = this.document.children.find((c) => c.type.name === 'Version');
        return new VCard.Version(child);
    }
    /** An array of all children of type "Source". */
    get sources() {
        return this.document.children
            .filter((c) => c.type.name === 'Source')
            .map((c) => new VCard.Source(c));
    }
    /** The child document of type "Kind". */
    get kind() {
        const child = this.document.children.find((c) => c.type.name === 'Kind');
        return child ? new VCard.Kind(child) : undefined;
    }
    /** An array of all children of type "XML". */
    get xmls() {
        return this.document.children
            .filter((c) => c.type.name === 'XML')
            .map((c) => new VCard.XML(c));
    }
    /** The child document of type "Name". */
    get name() {
        const child = this.document.children.find((c) => c.type.name === 'Name');
        return child ? new VCard.Name(child) : undefined;
    }
    /** The child document of type "FormattedName". */
    get formattedName() {
        const child = this.document.children.find((c) => c.type.name === 'FormattedName');
        return child ? new VCard.FormattedName(child) : undefined;
    }
    /** An array of all children of type "Nickname". */
    get nicknames() {
        return this.document.children
            .filter((c) => c.type.name === 'Nickname')
            .map((c) => new VCard.Nickname(c));
    }
    /** The child document of type "Birthday". */
    get birthday() {
        const child = this.document.children.find((c) => c.type.name === 'Birthday');
        return child ? new VCard.Birthday(child) : undefined;
    }
    /** The child document of type "Anniversary". */
    get anniversary() {
        const child = this.document.children.find((c) => c.type.name === 'Anniversary');
        return child ? new VCard.Anniversary(child) : undefined;
    }
    /** The child document of type "Gender". */
    get gender() {
        const child = this.document.children.find((c) => c.type.name === 'Gender');
        return child ? new VCard.Gender(child) : undefined;
    }
    /** An array of all children of type "DeliveryAddress". */
    get deliveryAddresses() {
        return this.document.children
            .filter((c) => c.type.name === 'DeliveryAddress')
            .map((c) => new VCard.DeliveryAddress(c));
    }
    /** An array of all children of type "Label". */
    get labels() {
        return this.document.children
            .filter((c) => c.type.name === 'Label')
            .map((c) => new VCard.Label(c));
    }
    /** An array of all children of type "Photo". */
    get photos() {
        return this.document.children
            .filter((c) => c.type.name === 'Photo')
            .map((c) => new VCard.Photo(c));
    }
    /** An array of all children of type "TelephoneNumber". */
    get telephoneNumbers() {
        return this.document.children
            .filter((c) => c.type.name === 'TelephoneNumber')
            .map((c) => new VCard.TelephoneNumber(c));
    }
    /** An array of all children of type "Email". */
    get emails() {
        return this.document.children
            .filter((c) => c.type.name === 'Email')
            .map((c) => new VCard.Email(c));
    }
    /** An array of all children of type "IMPP". */
    get impps() {
        return this.document.children
            .filter((c) => c.type.name === 'IMPP')
            .map((c) => new VCard.IMPP(c));
    }
    /** An array of all children of type "Language". */
    get languages() {
        return this.document.children
            .filter((c) => c.type.name === 'Language')
            .map((c) => new VCard.Language(c));
    }
    /** An array of all children of type "TimeZone". */
    get timeZones() {
        return this.document.children
            .filter((c) => c.type.name === 'TimeZone')
            .map((c) => new VCard.TimeZone(c));
    }
    /** An array of all children of type "GeoLocation". */
    get geoLocations() {
        return this.document.children
            .filter((c) => c.type.name === 'GeoLocation')
            .map((c) => new VCard.GeoLocation(c));
    }
    /** An array of all children of type "Title". */
    get titles() {
        return this.document.children
            .filter((c) => c.type.name === 'Title')
            .map((c) => new VCard.Title(c));
    }
    /** An array of all children of type "Role". */
    get roles() {
        return this.document.children
            .filter((c) => c.type.name === 'Role')
            .map((c) => new VCard.Role(c));
    }
    /** An array of all children of type "Logo". */
    get logos() {
        return this.document.children
            .filter((c) => c.type.name === 'Logo')
            .map((c) => new VCard.Logo(c));
    }
    /** An array of all children of type "Agent". */
    get agents() {
        return this.document.children
            .filter((c) => c.type.name === 'Agent')
            .map((c) => new VCard.Agent(c));
    }
    /** An array of all children of type "Organisation". */
    get organisations() {
        return this.document.children
            .filter((c) => c.type.name === 'Organisation')
            .map((c) => new VCard.Organisation(c));
    }
    /** An array of all children of type "Member". */
    get members() {
        return this.document.children
            .filter((c) => c.type.name === 'Member')
            .map((c) => new VCard.Member(c));
    }
    /** An array of all children of type "Related". */
    get relateds() {
        return this.document.children
            .filter((c) => c.type.name === 'Related')
            .map((c) => new VCard.Related(c));
    }
    /** An array of all children of type "Category". */
    get categories() {
        return this.document.children
            .filter((c) => c.type.name === 'Category')
            .map((c) => new VCard.Category(c));
    }
    /** An array of all children of type "Note". */
    get notes() {
        return this.document.children
            .filter((c) => c.type.name === 'Note')
            .map((c) => new VCard.Note(c));
    }
    /** The child document of type "ProductId". */
    get productId() {
        const child = this.document.children.find((c) => c.type.name === 'ProductId');
        return child ? new VCard.ProductId(child) : undefined;
    }
    /** The child document of type "Revision". */
    get revision() {
        const child = this.document.children.find((c) => c.type.name === 'Revision');
        return child ? new VCard.Revision(child) : undefined;
    }
    /** An array of all children of type "Sound". */
    get sounds() {
        return this.document.children
            .filter((c) => c.type.name === 'Sound')
            .map((c) => new VCard.Sound(c));
    }
    /** The child document of type "UID". */
    get uid() {
        const child = this.document.children.find((c) => c.type.name === 'UID');
        return child ? new VCard.UID(child) : undefined;
    }
    /** An array of all children of type "ClientPIDMap". */
    get clientPIDMaps() {
        return this.document.children
            .filter((c) => c.type.name === 'ClientPIDMap')
            .map((c) => new VCard.ClientPIDMap(c));
    }
    /** An array of all children of type "URL". */
    get urls() {
        return this.document.children
            .filter((c) => c.type.name === 'URL')
            .map((c) => new VCard.URL(c));
    }
    /** An array of all children of type "PublicKey". */
    get publicKeys() {
        return this.document.children
            .filter((c) => c.type.name === 'PublicKey')
            .map((c) => new VCard.PublicKey(c));
    }
    /** An array of all children of type "BusyTimeURL". */
    get busyTimeURLs() {
        return this.document.children
            .filter((c) => c.type.name === 'BusyTimeURL')
            .map((c) => new VCard.BusyTimeURL(c));
    }
    /** An array of all children of type "CalendarURIForRequests". */
    get calendarURIForRequestss() {
        return this.document.children
            .filter((c) => c.type.name === 'CalendarURIForRequests')
            .map((c) => new VCard.CalendarURIForRequests(c));
    }
    /** An array of all children of type "CalendarURI". */
    get calendarURIs() {
        return this.document.children
            .filter((c) => c.type.name === 'CalendarURI')
            .map((c) => new VCard.CalendarURI(c));
    }
    /** The child document of type "SortString". */
    get sortString() {
        const child = this.document.children.find((c) => c.type.name === 'SortString');
        return child ? new VCard.SortString(child) : undefined;
    }
    /** The child document of type "Classification". */
    get classification() {
        const child = this.document.children.find((c) => c.type.name === 'Classification');
        return child ? new VCard.Classification(child) : undefined;
    }
    /** An array of all children of type "Custom". */
    get customs() {
        return this.document.children
            .filter((c) => c.type.name === 'Custom')
            .map((c) => new VCard.Custom(c));
    }
}
VCard.DOCUMENT_TYPE = 'VCard';
(function (VCard) {
    /** VCard Entry */
    class Entry {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Raw Value */
        get rawValue() {
            return this.document.fields.find((f) => f.type.name === 'RawValue');
        }
        /** Type Modifier */
        get typeModifiers() {
            return this.document.fields.filter((f) => f.type.name === 'TypeModifier');
        }
        /** Value */
        get values() {
            return this.document.fields.filter((f) => f.type.name === 'Value');
        }
    }
    Entry.RAW_VALUE_FIELD_NAME = 'RawValue';
    Entry.RAW_VALUE_FIELD_NAME_NORMALIZED = 'VCard.Entry.RawValue';
    Entry.TYPE_MODIFIER_FIELD_NAME = 'TypeModifier';
    Entry.TYPE_MODIFIER_FIELD_NAME_NORMALIZED = 'VCard.Entry.TypeModifier';
    Entry.VALUE_FIELD_NAME = 'Value';
    Entry.VALUE_FIELD_NAME_NORMALIZED = 'VCard.Entry.Value';
    VCard.Entry = Entry;
    /** Version */
    class Version extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Version.DOCUMENT_TYPE;
        }
    }
    Version.DOCUMENT_TYPE = 'Version';
    VCard.Version = Version;
    /** Source */
    class Source extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Source.DOCUMENT_TYPE;
        }
    }
    Source.DOCUMENT_TYPE = 'Source';
    VCard.Source = Source;
    /** Kind */
    class Kind extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Kind.DOCUMENT_TYPE;
        }
    }
    Kind.DOCUMENT_TYPE = 'Kind';
    VCard.Kind = Kind;
    /** XML */
    class XML extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.XML.DOCUMENT_TYPE;
        }
    }
    XML.DOCUMENT_TYPE = 'XML';
    VCard.XML = XML;
    /** Name */
    class Name extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Name.DOCUMENT_TYPE;
        }
    }
    Name.DOCUMENT_TYPE = 'Name';
    VCard.Name = Name;
    /** Formatted Name */
    class FormattedName extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.FormattedName.DOCUMENT_TYPE;
        }
    }
    FormattedName.DOCUMENT_TYPE = 'FormattedName';
    VCard.FormattedName = FormattedName;
    /** Nickname */
    class Nickname extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Nickname.DOCUMENT_TYPE;
        }
    }
    Nickname.DOCUMENT_TYPE = 'Nickname';
    VCard.Nickname = Nickname;
    /** Birthday */
    class Birthday extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Birthday.DOCUMENT_TYPE;
        }
    }
    Birthday.DOCUMENT_TYPE = 'Birthday';
    VCard.Birthday = Birthday;
    /** Anniversary */
    class Anniversary extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Anniversary.DOCUMENT_TYPE;
        }
    }
    Anniversary.DOCUMENT_TYPE = 'Anniversary';
    VCard.Anniversary = Anniversary;
    /** Gender */
    class Gender extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Gender.DOCUMENT_TYPE;
        }
    }
    Gender.DOCUMENT_TYPE = 'Gender';
    VCard.Gender = Gender;
    /** Delivery Address */
    class DeliveryAddress extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.DeliveryAddress.DOCUMENT_TYPE;
        }
    }
    DeliveryAddress.DOCUMENT_TYPE = 'DeliveryAddress';
    VCard.DeliveryAddress = DeliveryAddress;
    /** Label */
    class Label extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Label.DOCUMENT_TYPE;
        }
    }
    Label.DOCUMENT_TYPE = 'Label';
    VCard.Label = Label;
    /** Photo */
    class Photo extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Photo.DOCUMENT_TYPE;
        }
    }
    Photo.DOCUMENT_TYPE = 'Photo';
    VCard.Photo = Photo;
    /** Telephone Number */
    class TelephoneNumber extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.TelephoneNumber.DOCUMENT_TYPE;
        }
    }
    TelephoneNumber.DOCUMENT_TYPE = 'TelephoneNumber';
    VCard.TelephoneNumber = TelephoneNumber;
    /** Email */
    class Email extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Email.DOCUMENT_TYPE;
        }
    }
    Email.DOCUMENT_TYPE = 'Email';
    VCard.Email = Email;
    /** IMPP */
    class IMPP extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.IMPP.DOCUMENT_TYPE;
        }
    }
    IMPP.DOCUMENT_TYPE = 'IMPP';
    VCard.IMPP = IMPP;
    /** Language */
    class Language extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Language.DOCUMENT_TYPE;
        }
    }
    Language.DOCUMENT_TYPE = 'Language';
    VCard.Language = Language;
    /** Time Zone */
    class TimeZone extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.TimeZone.DOCUMENT_TYPE;
        }
    }
    TimeZone.DOCUMENT_TYPE = 'TimeZone';
    VCard.TimeZone = TimeZone;
    /** Geo Location */
    class GeoLocation extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.GeoLocation.DOCUMENT_TYPE;
        }
    }
    GeoLocation.DOCUMENT_TYPE = 'GeoLocation';
    VCard.GeoLocation = GeoLocation;
    /** Title */
    class Title extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Title.DOCUMENT_TYPE;
        }
    }
    Title.DOCUMENT_TYPE = 'Title';
    VCard.Title = Title;
    /** Role */
    class Role extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Role.DOCUMENT_TYPE;
        }
    }
    Role.DOCUMENT_TYPE = 'Role';
    VCard.Role = Role;
    /** Logo */
    class Logo extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Logo.DOCUMENT_TYPE;
        }
    }
    Logo.DOCUMENT_TYPE = 'Logo';
    VCard.Logo = Logo;
    /** Agent */
    class Agent extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Agent.DOCUMENT_TYPE;
        }
    }
    Agent.DOCUMENT_TYPE = 'Agent';
    VCard.Agent = Agent;
    /** Organisation */
    class Organisation extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Organisation.DOCUMENT_TYPE;
        }
    }
    Organisation.DOCUMENT_TYPE = 'Organisation';
    VCard.Organisation = Organisation;
    /** Member */
    class Member extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Member.DOCUMENT_TYPE;
        }
    }
    Member.DOCUMENT_TYPE = 'Member';
    VCard.Member = Member;
    /** Related */
    class Related extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Related.DOCUMENT_TYPE;
        }
    }
    Related.DOCUMENT_TYPE = 'Related';
    VCard.Related = Related;
    /** Category */
    class Category extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Category.DOCUMENT_TYPE;
        }
    }
    Category.DOCUMENT_TYPE = 'Category';
    VCard.Category = Category;
    /** Note */
    class Note extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Note.DOCUMENT_TYPE;
        }
    }
    Note.DOCUMENT_TYPE = 'Note';
    VCard.Note = Note;
    /** ProductId */
    class ProductId extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.ProductId.DOCUMENT_TYPE;
        }
    }
    ProductId.DOCUMENT_TYPE = 'ProductId';
    VCard.ProductId = ProductId;
    /** Revision */
    class Revision extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Revision.DOCUMENT_TYPE;
        }
    }
    Revision.DOCUMENT_TYPE = 'Revision';
    VCard.Revision = Revision;
    /** Sound */
    class Sound extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Sound.DOCUMENT_TYPE;
        }
    }
    Sound.DOCUMENT_TYPE = 'Sound';
    VCard.Sound = Sound;
    /** UID */
    class UID extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.UID.DOCUMENT_TYPE;
        }
    }
    UID.DOCUMENT_TYPE = 'UID';
    VCard.UID = UID;
    /** Client PID Map */
    class ClientPIDMap extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.ClientPIDMap.DOCUMENT_TYPE;
        }
    }
    ClientPIDMap.DOCUMENT_TYPE = 'ClientPIDMap';
    VCard.ClientPIDMap = ClientPIDMap;
    /** URL */
    class URL extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.URL.DOCUMENT_TYPE;
        }
    }
    URL.DOCUMENT_TYPE = 'URL';
    VCard.URL = URL;
    /** Public Key */
    class PublicKey extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.PublicKey.DOCUMENT_TYPE;
        }
    }
    PublicKey.DOCUMENT_TYPE = 'PublicKey';
    VCard.PublicKey = PublicKey;
    /** Busy Time URL */
    class BusyTimeURL extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.BusyTimeURL.DOCUMENT_TYPE;
        }
    }
    BusyTimeURL.DOCUMENT_TYPE = 'BusyTimeURL';
    VCard.BusyTimeURL = BusyTimeURL;
    /** Calendar URI For Requests */
    class CalendarURIForRequests extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.CalendarURIForRequests.DOCUMENT_TYPE;
        }
    }
    CalendarURIForRequests.DOCUMENT_TYPE = 'CalendarURIForRequests';
    VCard.CalendarURIForRequests = CalendarURIForRequests;
    /** Calendar URI */
    class CalendarURI extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.CalendarURI.DOCUMENT_TYPE;
        }
    }
    CalendarURI.DOCUMENT_TYPE = 'CalendarURI';
    VCard.CalendarURI = CalendarURI;
    /** Sort String */
    class SortString extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.SortString.DOCUMENT_TYPE;
        }
    }
    SortString.DOCUMENT_TYPE = 'SortString';
    VCard.SortString = SortString;
    /** Classification */
    class Classification extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Classification.DOCUMENT_TYPE;
        }
    }
    Classification.DOCUMENT_TYPE = 'Classification';
    VCard.Classification = Classification;
    /** Custom */
    class Custom extends Entry {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return VCard.Custom.DOCUMENT_TYPE;
        }
    }
    Custom.DOCUMENT_TYPE = 'Custom';
    VCard.Custom = Custom;
})(VCard || (VCard = {}));
/** British Columbia (Canada) driver license */
export class BritishColumbiaDriverLicense {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BritishColumbiaDriverLicense.DOCUMENT_TYPE;
    }
    /** Address */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Birth date in CCYYMMDD format */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Card expiry in YYMM format */
    get cardExpiry() {
        return this.document.fields.find((f) => f.type.name === 'CardExpiry');
    }
    /** Card Number */
    get cardNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardNumber');
    }
    /** City */
    get city() {
        return this.document.fields.find((f) => f.type.name === 'City');
    }
    /** Error control code */
    get errorControlCode() {
        return this.document.fields.find((f) => f.type.name === 'ErrorControlCode');
    }
    /** Eye color */
    get eyeColor() {
        return this.document.fields.find((f) => f.type.name === 'EyeColor');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Hair color */
    get hairColor() {
        return this.document.fields.find((f) => f.type.name === 'HairColor');
    }
    /** Height */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Last name */
    get lastName() {
        return this.document.fields.find((f) => f.type.name === 'LastName');
    }
    /** Personal health number */
    get personalHealthNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalHealthNumber');
    }
    /** Postal code */
    get postalCode() {
        return this.document.fields.find((f) => f.type.name === 'PostalCode');
    }
    /** Province */
    get province() {
        return this.document.fields.find((f) => f.type.name === 'Province');
    }
    /** Province code */
    get provinceCode() {
        return this.document.fields.find((f) => f.type.name === 'ProvinceCode');
    }
    /** Security function */
    get securityFunction() {
        return this.document.fields.find((f) => f.type.name === 'SecurityFunction');
    }
    /** Security Version */
    get securityVersion() {
        return this.document.fields.find((f) => f.type.name === 'SecurityVersion');
    }
    /** Sex */
    get sex() {
        return this.document.fields.find((f) => f.type.name === 'Sex');
    }
    /** Version */
    get version() {
        return this.document.fields.find((f) => f.type.name === 'Version');
    }
    /** Weight */
    get weight() {
        return this.document.fields.find((f) => f.type.name === 'Weight');
    }
}
BritishColumbiaDriverLicense.DOCUMENT_TYPE = 'BritishColumbiaDriverLicense';
BritishColumbiaDriverLicense.ADDRESS_FIELD_NAME = 'Address';
BritishColumbiaDriverLicense.ADDRESS_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Address';
BritishColumbiaDriverLicense.BIRTH_DATE_FIELD_NAME = 'BirthDate';
BritishColumbiaDriverLicense.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.BirthDate';
BritishColumbiaDriverLicense.CARD_EXPIRY_FIELD_NAME = 'CardExpiry';
BritishColumbiaDriverLicense.CARD_EXPIRY_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.CardExpiry';
BritishColumbiaDriverLicense.CARD_NUMBER_FIELD_NAME = 'CardNumber';
BritishColumbiaDriverLicense.CARD_NUMBER_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.CardNumber';
BritishColumbiaDriverLicense.CITY_FIELD_NAME = 'City';
BritishColumbiaDriverLicense.CITY_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.City';
BritishColumbiaDriverLicense.ERROR_CONTROL_CODE_FIELD_NAME = 'ErrorControlCode';
BritishColumbiaDriverLicense.ERROR_CONTROL_CODE_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.ErrorControlCode';
BritishColumbiaDriverLicense.EYE_COLOR_FIELD_NAME = 'EyeColor';
BritishColumbiaDriverLicense.EYE_COLOR_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.EyeColor';
BritishColumbiaDriverLicense.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
BritishColumbiaDriverLicense.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.GivenNames';
BritishColumbiaDriverLicense.HAIR_COLOR_FIELD_NAME = 'HairColor';
BritishColumbiaDriverLicense.HAIR_COLOR_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.HairColor';
BritishColumbiaDriverLicense.HEIGHT_FIELD_NAME = 'Height';
BritishColumbiaDriverLicense.HEIGHT_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Height';
BritishColumbiaDriverLicense.LAST_NAME_FIELD_NAME = 'LastName';
BritishColumbiaDriverLicense.LAST_NAME_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.LastName';
BritishColumbiaDriverLicense.PERSONAL_HEALTH_NUMBER_FIELD_NAME = 'PersonalHealthNumber';
BritishColumbiaDriverLicense.PERSONAL_HEALTH_NUMBER_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.PersonalHealthNumber';
BritishColumbiaDriverLicense.POSTAL_CODE_FIELD_NAME = 'PostalCode';
BritishColumbiaDriverLicense.POSTAL_CODE_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.PostalCode';
BritishColumbiaDriverLicense.PROVINCE_FIELD_NAME = 'Province';
BritishColumbiaDriverLicense.PROVINCE_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Province';
BritishColumbiaDriverLicense.PROVINCE_CODE_FIELD_NAME = 'ProvinceCode';
BritishColumbiaDriverLicense.PROVINCE_CODE_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.ProvinceCode';
BritishColumbiaDriverLicense.SECURITY_FUNCTION_FIELD_NAME = 'SecurityFunction';
BritishColumbiaDriverLicense.SECURITY_FUNCTION_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.SecurityFunction';
BritishColumbiaDriverLicense.SECURITY_VERSION_FIELD_NAME = 'SecurityVersion';
BritishColumbiaDriverLicense.SECURITY_VERSION_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.SecurityVersion';
BritishColumbiaDriverLicense.SEX_FIELD_NAME = 'Sex';
BritishColumbiaDriverLicense.SEX_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Sex';
BritishColumbiaDriverLicense.VERSION_FIELD_NAME = 'Version';
BritishColumbiaDriverLicense.VERSION_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Version';
BritishColumbiaDriverLicense.WEIGHT_FIELD_NAME = 'Weight';
BritishColumbiaDriverLicense.WEIGHT_FIELD_NAME_NORMALIZED = 'BritishColumbiaDriverLicense.Weight';
/** AAMVA */
export class AAMVA {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return AAMVA.DOCUMENT_TYPE;
    }
    /** Issuer Identification Number */
    get issuerIdentificationNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerIdentificationNumber');
    }
    /** Jurisdiction Version Number */
    get jurisdictionVersionNumber() {
        return this.document.fields.find((f) => f.type.name === 'JurisdictionVersionNumber');
    }
    /** Version */
    get version() {
        return this.document.fields.find((f) => f.type.name === 'Version');
    }
    /** The child document of type "TitleData". */
    get titleData() {
        const child = this.document.children.find((c) => c.type.name === 'TitleData');
        return child ? new AAMVA.TitleData(child) : undefined;
    }
    /** The child document of type "RegistrationData". */
    get registrationData() {
        const child = this.document.children.find((c) => c.type.name === 'RegistrationData');
        return child ? new AAMVA.RegistrationData(child) : undefined;
    }
    /** The child document of type "MotorCarrierData". */
    get motorCarrierData() {
        const child = this.document.children.find((c) => c.type.name === 'MotorCarrierData');
        return child ? new AAMVA.MotorCarrierData(child) : undefined;
    }
    /** The child document of type "RegistrantAndVehicleData". */
    get registrantAndVehicleData() {
        const child = this.document.children.find((c) => c.type.name === 'RegistrantAndVehicleData');
        return child ? new AAMVA.RegistrantAndVehicleData(child) : undefined;
    }
    /** The child document of type "VehicleOwnerData". */
    get vehicleOwnerData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleOwnerData');
        return child ? new AAMVA.VehicleOwnerData(child) : undefined;
    }
    /** The child document of type "VehicleData". */
    get vehicleData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleData');
        return child ? new AAMVA.VehicleData(child) : undefined;
    }
    /** The child document of type "VehicleSafetyInspectionData". */
    get vehicleSafetyInspectionData() {
        const child = this.document.children.find((c) => c.type.name === 'VehicleSafetyInspectionData');
        return child ? new AAMVA.VehicleSafetyInspectionData(child) : undefined;
    }
    /** The child document of type "DriverLicense". */
    get driverLicense() {
        const child = this.document.children.find((c) => c.type.name === 'DriverLicense');
        return child ? new AAMVA.DriverLicense(child) : undefined;
    }
    /** The child document of type "IDCard". */
    get idCard() {
        const child = this.document.children.find((c) => c.type.name === 'IDCard');
        return child ? new AAMVA.IDCard(child) : undefined;
    }
    /** The child document of type "EnhancedDriverLicense". */
    get enhancedDriverLicense() {
        const child = this.document.children.find((c) => c.type.name === 'EnhancedDriverLicense');
        return child ? new AAMVA.EnhancedDriverLicense(child) : undefined;
    }
    /** The child document of type "RawDocument". */
    get rawDocument() {
        const child = this.document.children.find((c) => c.type.name === 'RawDocument');
        return new AAMVA.RawDocument(child);
    }
}
AAMVA.DOCUMENT_TYPE = 'AAMVA';
AAMVA.ISSUER_IDENTIFICATION_NUMBER_FIELD_NAME = 'IssuerIdentificationNumber';
AAMVA.ISSUER_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.IssuerIdentificationNumber';
AAMVA.JURISDICTION_VERSION_NUMBER_FIELD_NAME = 'JurisdictionVersionNumber';
AAMVA.JURISDICTION_VERSION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.JurisdictionVersionNumber';
AAMVA.VERSION_FIELD_NAME = 'Version';
AAMVA.VERSION_FIELD_NAME_NORMALIZED = 'AAMVA.Version';
(function (AAMVA) {
    /** Title Data. File type "TD". */
    class TitleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.TitleData.DOCUMENT_TYPE;
        }
        /** Data element ID "NAT". City portion of the owner’s address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "NAU". Jurisdiction portion of the owner’s address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "NAR". Street portion of the owner’s address. */
        get addressStreet() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet');
        }
        /** Data element ID "NAV". The ZIP code or Postal code portion of the owner’s address. */
        get addressZipCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressZipCode');
        }
        /** Data element ID "BBC". The name of business that owns the vehicle. */
        get businessName() {
            return this.document.fields.find((f) => f.type.name === 'BusinessName');
        }
        /** Data element ID "NAA". Family name (commonly called surname or last name) of the owner of the vehicle. */
        get familyName() {
            return this.document.fields.find((f) => f.type.name === 'FamilyName');
        }
        /** Data element ID "LAF". A code that uniquely identifies the first holder of a lien. */
        get firstLienHolderId() {
            return this.document.fields.find((f) => f.type.name === 'FirstLienHolderId');
        }
        /** Data element ID "LAA". Name of the first lien holder of the vehicle. */
        get firstLienHolderName() {
            return this.document.fields.find((f) => f.type.name === 'FirstLienHolderName');
        }
        /** Data element ID "NAE". Given name or names (includes all of what are commonly referred to as first and middle names) of the owner of the vehicle. */
        get givenName() {
            return this.document.fields.find((f) => f.type.name === 'GivenName');
        }
        /** Data element ID "TAW". This code represents whether the vehicle/vessel is new or used. Note: jurisdictions’ definitions of these classifications may vary a little due to state regulations on demo vehicles, slates between dealers, application of state taxes, etc. N = New, U = Used. */
        get newUsedIndicator() {
            return this.document.fields.find((f) => f.type.name === 'NewUsedIndicator');
        }
        /** Data element ID "TAH". The date the odometer reading was recorded by the jurisdiction. */
        get odometerDate() {
            return this.document.fields.find((f) => f.type.name === 'OdometerDate');
        }
        /** Data element ID "TAG". This is the federal odometer mileage disclosure. The mandatory information is: (1) Actual vehicle mileage; (2) Mileage exceeds mechanical limitations; (3) Not actual mileage; (4) Mileage disclosure not required. */
        get odometerDisclosure() {
            return this.document.fields.find((f) => f.type.name === 'OdometerDisclosure');
        }
        /** Data element ID "TAI". This is the odometer reading registered with the DMV either at the time of titling or registration renewal in kilometers. */
        get odometerReadingKilometers() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingKilometers');
        }
        /** Data element ID "TAF". This is the odometer reading registered with the DMV either at the time of titling or registration renewal. */
        get odometerReadingMileage() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingMileage');
        }
        /** Data element ID "TAZ". The title number assigned to the vehicle by the previous titling jurisdiction. */
        get previousTitleNumber() {
            return this.document.fields.find((f) => f.type.name === 'PreviousTitleNumber');
        }
        /** Data element ID "TPJ". The code for the jurisdiction (U.S., Canadian, or Mexican) that titled the vehicle immediately prior to the current titling jurisdiction. */
        get previousTitlingJurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'PreviousTitlingJurisdiction');
        }
        /** Data element ID "TAY". Code providing information about the brand applied to the title. */
        get titleBrand() {
            return this.document.fields.find((f) => f.type.name === 'TitleBrand');
        }
        /** Data element ID "TAV". The date the jurisdiction’s titling authority issued a title to the owner of the vehicle. The format is CCYYMMDD. */
        get titleIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'TitleIssueDate');
        }
        /** Data element ID "TAA". The date the jurisdiction’s titling authority issued a title to the owner of the vehicle. The format is CCYYMMDD. */
        get titleNumber() {
            return this.document.fields.find((f) => f.type.name === 'TitleNumber');
        }
        /** Data element ID "TAC". A unique set of alphanumeric characters assigned by the titling jurisdiction to the certificate of title of a vehicle. */
        get titlingJurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'TitlingJurisdiction');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2-character alphanumeric. */
        get vehicleBodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyStyle');
        }
        /** Data element ID "VBD". Where the vehicle/vessel is one color, this is the appropriate code describing that color. When the vehicle is two colors, this is the code for the top-most or front-most color. */
        get vehicleColor() {
            return this.document.fields.find((f) => f.type.name === 'VehicleColor');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". A code denoting a family of vehicles (within a make), which has a degree of similarity in construction, such as body, chassis, etc. The field does not necessarily contain a standard code; it may contain a value provided by the originator of the field. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAL". The year that is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
        /** Data element ID "TAU". The date a vehicle was purchased by the current owner. The format is ISO8601 with delimiters. */
        get vehiclePurchaseDate() {
            return this.document.fields.find((f) => f.type.name === 'VehiclePurchaseDate');
        }
    }
    TitleData.DOCUMENT_TYPE = 'TitleData';
    TitleData.ADDRESS_CITY_FIELD_NAME = 'AddressCity';
    TitleData.ADDRESS_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.AddressCity';
    TitleData.ADDRESS_JURISDICTION_CODE_FIELD_NAME = 'AddressJurisdictionCode';
    TitleData.ADDRESS_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.AddressJurisdictionCode';
    TitleData.ADDRESS_STREET_FIELD_NAME = 'AddressStreet';
    TitleData.ADDRESS_STREET_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.AddressStreet';
    TitleData.ADDRESS_ZIP_CODE_FIELD_NAME = 'AddressZipCode';
    TitleData.ADDRESS_ZIP_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.AddressZipCode';
    TitleData.BUSINESS_NAME_FIELD_NAME = 'BusinessName';
    TitleData.BUSINESS_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.BusinessName';
    TitleData.FAMILY_NAME_FIELD_NAME = 'FamilyName';
    TitleData.FAMILY_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.FamilyName';
    TitleData.FIRST_LIEN_HOLDER_ID_FIELD_NAME = 'FirstLienHolderId';
    TitleData.FIRST_LIEN_HOLDER_ID_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.FirstLienHolderId';
    TitleData.FIRST_LIEN_HOLDER_NAME_FIELD_NAME = 'FirstLienHolderName';
    TitleData.FIRST_LIEN_HOLDER_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.FirstLienHolderName';
    TitleData.GIVEN_NAME_FIELD_NAME = 'GivenName';
    TitleData.GIVEN_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.GivenName';
    TitleData.NEW_USED_INDICATOR_FIELD_NAME = 'NewUsedIndicator';
    TitleData.NEW_USED_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.NewUsedIndicator';
    TitleData.ODOMETER_DATE_FIELD_NAME = 'OdometerDate';
    TitleData.ODOMETER_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.OdometerDate';
    TitleData.ODOMETER_DISCLOSURE_FIELD_NAME = 'OdometerDisclosure';
    TitleData.ODOMETER_DISCLOSURE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.OdometerDisclosure';
    TitleData.ODOMETER_READING_KILOMETERS_FIELD_NAME = 'OdometerReadingKilometers';
    TitleData.ODOMETER_READING_KILOMETERS_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.OdometerReadingKilometers';
    TitleData.ODOMETER_READING_MILEAGE_FIELD_NAME = 'OdometerReadingMileage';
    TitleData.ODOMETER_READING_MILEAGE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.OdometerReadingMileage';
    TitleData.PREVIOUS_TITLE_NUMBER_FIELD_NAME = 'PreviousTitleNumber';
    TitleData.PREVIOUS_TITLE_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.PreviousTitleNumber';
    TitleData.PREVIOUS_TITLING_JURISDICTION_FIELD_NAME = 'PreviousTitlingJurisdiction';
    TitleData.PREVIOUS_TITLING_JURISDICTION_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.PreviousTitlingJurisdiction';
    TitleData.TITLE_BRAND_FIELD_NAME = 'TitleBrand';
    TitleData.TITLE_BRAND_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.TitleBrand';
    TitleData.TITLE_ISSUE_DATE_FIELD_NAME = 'TitleIssueDate';
    TitleData.TITLE_ISSUE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.TitleIssueDate';
    TitleData.TITLE_NUMBER_FIELD_NAME = 'TitleNumber';
    TitleData.TITLE_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.TitleNumber';
    TitleData.TITLING_JURISDICTION_FIELD_NAME = 'TitlingJurisdiction';
    TitleData.TITLING_JURISDICTION_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.TitlingJurisdiction';
    TitleData.VEHICLE_BODY_STYLE_FIELD_NAME = 'VehicleBodyStyle';
    TitleData.VEHICLE_BODY_STYLE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleBodyStyle';
    TitleData.VEHICLE_COLOR_FIELD_NAME = 'VehicleColor';
    TitleData.VEHICLE_COLOR_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleColor';
    TitleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME = 'VehicleIdentificationNumber';
    TitleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleIdentificationNumber';
    TitleData.VEHICLE_MAKE_FIELD_NAME = 'VehicleMake';
    TitleData.VEHICLE_MAKE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleMake';
    TitleData.VEHICLE_MODEL_FIELD_NAME = 'VehicleModel';
    TitleData.VEHICLE_MODEL_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleModel';
    TitleData.VEHICLE_MODEL_YEAR_FIELD_NAME = 'VehicleModelYear';
    TitleData.VEHICLE_MODEL_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehicleModelYear';
    TitleData.VEHICLE_PURCHASE_DATE_FIELD_NAME = 'VehiclePurchaseDate';
    TitleData.VEHICLE_PURCHASE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.TitleData.VehiclePurchaseDate';
    AAMVA.TitleData = TitleData;
    /** Registration Data. File type "RG". */
    class RegistrationData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.RegistrationData.DOCUMENT_TYPE;
        }
        /** Data element ID "RBK". City portion of the owner’s address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "RBL". Jurisdiction portion of the owner’s address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "RBI". Street portion of the owner’s address. */
        get addressStreet() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet');
        }
        /** Data element ID "RBM". The Zip code or Postal code of the vehicle owner’s residence address. */
        get addressZipCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressZipCode');
        }
        /** Data element ID "VBC". The number of common axles of rotation of one or more wheels of a vehicle, whether power driven or freely rotating. */
        get axles() {
            return this.document.fields.find((f) => f.type.name === 'Axles');
        }
        /** Data element ID "BBC". The business name of the first registrant of a vehicle. */
        get businessName() {
            return this.document.fields.find((f) => f.type.name === 'BusinessName');
        }
        /** Data element ID "FUL". The type of fuel used by the vehicle. In most cases, the fuel type would be diesel. */
        get fuel() {
            return this.document.fields.find((f) => f.type.name === 'Fuel');
        }
        /** Data element ID "VAT". The unladen weight of the vehicle (e.g., the single-unit truck, truck combination) plus the weight of the load being carried at a specific point in time. */
        get grossVehicleWeight() {
            return this.document.fields.find((f) => f.type.name === 'GrossVehicleWeight');
        }
        /** Data element ID "RBD". Family name (commonly called surname or last name) of the registered owner of a vehicle. */
        get registrantFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'RegistrantFamilyName');
        }
        /** Data element ID "RBE". Given name or names (includes all of what are commonly referred to as first and middle names) of the registered owner of a vehicle. */
        get registrantGivenName() {
            return this.document.fields.find((f) => f.type.name === 'RegistrantGivenName');
        }
        /** Data element ID "RAG". The date in which the registration expired. The format is ISO8601 with delimiters. */
        get registrationExpiryDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationExpiryDate');
        }
        /** Data element ID "RBB". The date in which the registration was issued. The format is ISO8601 with delimiters. */
        get registrationIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationIssueDate');
        }
        /** Data element ID "RAM". The characters assigned to a registration plate or tag affixed to the vehicle, assigned by the jurisdiction. */
        get registrationPlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationPlateNumber');
        }
        /** Data element ID "RBU". A unique number printed on the tab/decal and stored as part of the registration record. */
        get registrationWindowStickerDecal() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationWindowStickerDecal');
        }
        /** Data element ID "RBT". The year of registration. */
        get registrationYear() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationYear');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2-character alphanumeric. */
        get vehicleBodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyStyle');
        }
        /** Data element ID "VBD". Where the vehicle is one color, this is the appropriate code describing that color. When the vehicle is two colors, this is the code for the top-most or front-most color. */
        get vehicleColor() {
            return this.document.fields.find((f) => f.type.name === 'VehicleColor');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances my assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". A code denoting a family of vehicles (within a make), which has a degree of similarity in construction, such as body, chassis, etc. The field does not necessarily contain a standard code; it may contain a value provided by the originator of the field. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
        /** Data element ID "VPC". Indicates the use of the vehicle. */
        get vehicleUse() {
            return this.document.fields.find((f) => f.type.name === 'VehicleUse');
        }
    }
    RegistrationData.DOCUMENT_TYPE = 'RegistrationData';
    RegistrationData.ADDRESS_CITY_FIELD_NAME = 'AddressCity';
    RegistrationData.ADDRESS_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.AddressCity';
    RegistrationData.ADDRESS_JURISDICTION_CODE_FIELD_NAME = 'AddressJurisdictionCode';
    RegistrationData.ADDRESS_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.AddressJurisdictionCode';
    RegistrationData.ADDRESS_STREET_FIELD_NAME = 'AddressStreet';
    RegistrationData.ADDRESS_STREET_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.AddressStreet';
    RegistrationData.ADDRESS_ZIP_CODE_FIELD_NAME = 'AddressZipCode';
    RegistrationData.ADDRESS_ZIP_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.AddressZipCode';
    RegistrationData.AXLES_FIELD_NAME = 'Axles';
    RegistrationData.AXLES_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.Axles';
    RegistrationData.BUSINESS_NAME_FIELD_NAME = 'BusinessName';
    RegistrationData.BUSINESS_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.BusinessName';
    RegistrationData.FUEL_FIELD_NAME = 'Fuel';
    RegistrationData.FUEL_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.Fuel';
    RegistrationData.GROSS_VEHICLE_WEIGHT_FIELD_NAME = 'GrossVehicleWeight';
    RegistrationData.GROSS_VEHICLE_WEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.GrossVehicleWeight';
    RegistrationData.REGISTRANT_FAMILY_NAME_FIELD_NAME = 'RegistrantFamilyName';
    RegistrationData.REGISTRANT_FAMILY_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrantFamilyName';
    RegistrationData.REGISTRANT_GIVEN_NAME_FIELD_NAME = 'RegistrantGivenName';
    RegistrationData.REGISTRANT_GIVEN_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrantGivenName';
    RegistrationData.REGISTRATION_EXPIRY_DATE_FIELD_NAME = 'RegistrationExpiryDate';
    RegistrationData.REGISTRATION_EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrationExpiryDate';
    RegistrationData.REGISTRATION_ISSUE_DATE_FIELD_NAME = 'RegistrationIssueDate';
    RegistrationData.REGISTRATION_ISSUE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrationIssueDate';
    RegistrationData.REGISTRATION_PLATE_NUMBER_FIELD_NAME = 'RegistrationPlateNumber';
    RegistrationData.REGISTRATION_PLATE_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrationPlateNumber';
    RegistrationData.REGISTRATION_WINDOW_STICKER_DECAL_FIELD_NAME = 'RegistrationWindowStickerDecal';
    RegistrationData.REGISTRATION_WINDOW_STICKER_DECAL_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrationWindowStickerDecal';
    RegistrationData.REGISTRATION_YEAR_FIELD_NAME = 'RegistrationYear';
    RegistrationData.REGISTRATION_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.RegistrationYear';
    RegistrationData.VEHICLE_BODY_STYLE_FIELD_NAME = 'VehicleBodyStyle';
    RegistrationData.VEHICLE_BODY_STYLE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleBodyStyle';
    RegistrationData.VEHICLE_COLOR_FIELD_NAME = 'VehicleColor';
    RegistrationData.VEHICLE_COLOR_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleColor';
    RegistrationData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME = 'VehicleIdentificationNumber';
    RegistrationData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleIdentificationNumber';
    RegistrationData.VEHICLE_MAKE_FIELD_NAME = 'VehicleMake';
    RegistrationData.VEHICLE_MAKE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleMake';
    RegistrationData.VEHICLE_MODEL_FIELD_NAME = 'VehicleModel';
    RegistrationData.VEHICLE_MODEL_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleModel';
    RegistrationData.VEHICLE_MODEL_YEAR_FIELD_NAME = 'VehicleModelYear';
    RegistrationData.VEHICLE_MODEL_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleModelYear';
    RegistrationData.VEHICLE_USE_FIELD_NAME = 'VehicleUse';
    RegistrationData.VEHICLE_USE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrationData.VehicleUse';
    AAMVA.RegistrationData = RegistrationData;
    /** Motor Carrier Data. File type "MC". */
    class MotorCarrierData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.MotorCarrierData.DOCUMENT_TYPE;
        }
        /** Data element ID "MAA". The name of the carrier responsible for safety. This can be an individual, partnership or corporation responsible for the transportation of persons or property. This is the name that is recognized by law. */
        get carrierName() {
            return this.document.fields.find((f) => f.type.name === 'CarrierName');
        }
        /** Data element ID "MAL". This is the city for the mailing address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get city() {
            return this.document.fields.find((f) => f.type.name === 'City');
        }
        /** Data element ID "MAI". This is the jurisdiction of the residential address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get jurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'Jurisdiction');
        }
        /** Data element ID "MAK". This is the mailing address of the individual carrier. This information is utilized by the base jurisdiction to send information to the carrier that purchased the IRP credentials. */
        get streetAddress() {
            return this.document.fields.find((f) => f.type.name === 'StreetAddress');
        }
        /** Data element ID "MAN". A unique identifier assigned to the carrier responsible for safety issued by the U.S. Department of Transportation – Federal Motor Carrier Safety Administration. */
        get usdotNumber() {
            return this.document.fields.find((f) => f.type.name === 'USDOTNumber');
        }
        /** Data element ID "MAO". The ZIP or Postal code of the resident address of the vehicle owner. */
        get zip() {
            return this.document.fields.find((f) => f.type.name === 'Zip');
        }
    }
    MotorCarrierData.DOCUMENT_TYPE = 'MotorCarrierData';
    MotorCarrierData.CARRIER_NAME_FIELD_NAME = 'CarrierName';
    MotorCarrierData.CARRIER_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.CarrierName';
    MotorCarrierData.CITY_FIELD_NAME = 'City';
    MotorCarrierData.CITY_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.City';
    MotorCarrierData.JURISDICTION_FIELD_NAME = 'Jurisdiction';
    MotorCarrierData.JURISDICTION_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.Jurisdiction';
    MotorCarrierData.STREET_ADDRESS_FIELD_NAME = 'StreetAddress';
    MotorCarrierData.STREET_ADDRESS_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.StreetAddress';
    MotorCarrierData.USDOT_NUMBER_FIELD_NAME = 'USDOTNumber';
    MotorCarrierData.USDOT_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.USDOTNumber';
    MotorCarrierData.ZIP_FIELD_NAME = 'Zip';
    MotorCarrierData.ZIP_FIELD_NAME_NORMALIZED = 'AAMVA.MotorCarrierData.Zip';
    AAMVA.MotorCarrierData = MotorCarrierData;
    /** Registrant And Vehicle Data. File type "IR". */
    class RegistrantAndVehicleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.RegistrantAndVehicleData.DOCUMENT_TYPE;
        }
        /** Data element ID "RBI". The first line of the registrant’s residence address. */
        get address() {
            return this.document.fields.find((f) => f.type.name === 'Address');
        }
        /** Data element ID "RAU". The declared base jurisdiction registration weight. */
        get baseJurisdictionRegisteredWeight() {
            return this.document.fields.find((f) => f.type.name === 'BaseJurisdictionRegisteredWeight');
        }
        /** Data element ID "RBC". The name of the first registrant of a vehicle. Registrant’s name may be a combined individual name or the name of a business */
        get carrierNameRegistrant() {
            return this.document.fields.find((f) => f.type.name === 'CarrierNameRegistrant');
        }
        /** Data element ID "RBK". The registrant’s residence city name. */
        get city() {
            return this.document.fields.find((f) => f.type.name === 'City');
        }
        /** Data element ID "VAT". The unladen weight of the vehicle (e.g., single-unit truck, truck combination) plus the weight of the maximum load for which vehicle registration fees have been paid within a particular jurisdiction. */
        get grossVehicleWeight() {
            return this.document.fields.find((f) => f.type.name === 'GrossVehicleWeight');
        }
        /** Data element ID "RBL". The state or province of the registrant’s residence address. */
        get jurisdiction() {
            return this.document.fields.find((f) => f.type.name === 'Jurisdiction');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is YY. */
        get modelYear() {
            return this.document.fields.find((f) => f.type.name === 'ModelYear');
        }
        /** Data element IDs "RAP", "VBC". The seat capacity of a commercial vehicle designed for transportation of more than then passengers. The number of common axles of rotation of one or more wheels of a vehicle, whether power design or freely rotating. */
        get numberOfSeats() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfSeats');
        }
        /** Data element ID "RAD". The number assigned to the registration decal in those jurisdictions that issue decals. */
        get registrationDecalNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationDecalNumber');
        }
        /** Data element ID "RAF". The registration enforcement date is the date that the current registration was enforced. This may or may not be the original registration date. The format is ISO8601 with delimiters */
        get registrationEnforcementDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationEnforcementDate');
        }
        /** Data element ID "RAG". The date in which the registration expired. The format is ISO8601 with delimiters. */
        get registrationExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationExpirationDate');
        }
        /** Data element ID "IFJ". The date in which the registration was issued. The format is ISO8601 with delimiters. */
        get registrationIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationIssueDate');
        }
        /** Data element ID "RAM". The characters assigned to a registration plate or tag affixed to the vehicle, assigned by the jurisdiction. */
        get registrationPlateNumber() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationPlateNumber');
        }
        /** Data element ID "RBT". This field is the registration year assigned by the jurisdiction. The format is CCYY. */
        get registrationYear() {
            return this.document.fields.find((f) => f.type.name === 'RegistrationYear');
        }
        /** Data element ID "VBB". The type of vehicle operated for the transportation of persons or property in the furtherance of any commercial or industrial enterprise, for hire or not for hire. Not all states will use all values. */
        get typeOfVehicle() {
            return this.document.fields.find((f) => f.type.name === 'TypeOfVehicle');
        }
        /** Data element ID "IEG". A number, assigned by the registrant of the commercial vehicle or trailer, to identify the vehicle or trailer in the fleet. No two units in a fleet can have the same number. A.K.A vehicle unit number or owner’s equipment number. */
        get unitNumber() {
            return this.document.fields.find((f) => f.type.name === 'UnitNumber');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "RBM". The ZIP or Postal code of the resident address of the registrant. */
        get zipCode() {
            return this.document.fields.find((f) => f.type.name === 'ZipCode');
        }
    }
    RegistrantAndVehicleData.DOCUMENT_TYPE = 'RegistrantAndVehicleData';
    RegistrantAndVehicleData.ADDRESS_FIELD_NAME = 'Address';
    RegistrantAndVehicleData.ADDRESS_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.Address';
    RegistrantAndVehicleData.BASE_JURISDICTION_REGISTERED_WEIGHT_FIELD_NAME = 'BaseJurisdictionRegisteredWeight';
    RegistrantAndVehicleData.BASE_JURISDICTION_REGISTERED_WEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.BaseJurisdictionRegisteredWeight';
    RegistrantAndVehicleData.CARRIER_NAME_REGISTRANT_FIELD_NAME = 'CarrierNameRegistrant';
    RegistrantAndVehicleData.CARRIER_NAME_REGISTRANT_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.CarrierNameRegistrant';
    RegistrantAndVehicleData.CITY_FIELD_NAME = 'City';
    RegistrantAndVehicleData.CITY_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.City';
    RegistrantAndVehicleData.GROSS_VEHICLE_WEIGHT_FIELD_NAME = 'GrossVehicleWeight';
    RegistrantAndVehicleData.GROSS_VEHICLE_WEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.GrossVehicleWeight';
    RegistrantAndVehicleData.JURISDICTION_FIELD_NAME = 'Jurisdiction';
    RegistrantAndVehicleData.JURISDICTION_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.Jurisdiction';
    RegistrantAndVehicleData.MODEL_YEAR_FIELD_NAME = 'ModelYear';
    RegistrantAndVehicleData.MODEL_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.ModelYear';
    RegistrantAndVehicleData.NUMBER_OF_SEATS_FIELD_NAME = 'NumberOfSeats';
    RegistrantAndVehicleData.NUMBER_OF_SEATS_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.NumberOfSeats';
    RegistrantAndVehicleData.REGISTRATION_DECAL_NUMBER_FIELD_NAME = 'RegistrationDecalNumber';
    RegistrantAndVehicleData.REGISTRATION_DECAL_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationDecalNumber';
    RegistrantAndVehicleData.REGISTRATION_ENFORCEMENT_DATE_FIELD_NAME = 'RegistrationEnforcementDate';
    RegistrantAndVehicleData.REGISTRATION_ENFORCEMENT_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationEnforcementDate';
    RegistrantAndVehicleData.REGISTRATION_EXPIRATION_DATE_FIELD_NAME = 'RegistrationExpirationDate';
    RegistrantAndVehicleData.REGISTRATION_EXPIRATION_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationExpirationDate';
    RegistrantAndVehicleData.REGISTRATION_ISSUE_DATE_FIELD_NAME = 'RegistrationIssueDate';
    RegistrantAndVehicleData.REGISTRATION_ISSUE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationIssueDate';
    RegistrantAndVehicleData.REGISTRATION_PLATE_NUMBER_FIELD_NAME = 'RegistrationPlateNumber';
    RegistrantAndVehicleData.REGISTRATION_PLATE_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationPlateNumber';
    RegistrantAndVehicleData.REGISTRATION_YEAR_FIELD_NAME = 'RegistrationYear';
    RegistrantAndVehicleData.REGISTRATION_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.RegistrationYear';
    RegistrantAndVehicleData.TYPE_OF_VEHICLE_FIELD_NAME = 'TypeOfVehicle';
    RegistrantAndVehicleData.TYPE_OF_VEHICLE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.TypeOfVehicle';
    RegistrantAndVehicleData.UNIT_NUMBER_FIELD_NAME = 'UnitNumber';
    RegistrantAndVehicleData.UNIT_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.UnitNumber';
    RegistrantAndVehicleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME = 'VehicleIdentificationNumber';
    RegistrantAndVehicleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.VehicleIdentificationNumber';
    RegistrantAndVehicleData.VEHICLE_MAKE_FIELD_NAME = 'VehicleMake';
    RegistrantAndVehicleData.VEHICLE_MAKE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.VehicleMake';
    RegistrantAndVehicleData.ZIP_CODE_FIELD_NAME = 'ZipCode';
    RegistrantAndVehicleData.ZIP_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.RegistrantAndVehicleData.ZipCode';
    AAMVA.RegistrantAndVehicleData = RegistrantAndVehicleData;
    /** Vehicle Owner Data. File type "OW". */
    class VehicleOwnerData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.VehicleOwnerData.DOCUMENT_TYPE;
        }
        /** Data element ID "NAX". The unique customer number/ID of the first vehicle owner. */
        get firstOwnerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerIdNumber');
        }
        /** Data element ID "NAB". Last Name or Surname of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get firstOwnerLastName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerLastName');
        }
        /** Data element ID "NBA". The legal status of the first vehicle owner. This is only used when a vehicle has multiple owners. A legal status may be ("AND", "OR"). */
        get firstOwnerLegalStatus() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerLegalStatus');
        }
        /** Data element ID "NAD". Middle Name(s) or Initial(s) of the Owner. Hyphenated names acceptable, spaces, between names acceptable, but no other use of special symbols. */
        get firstOwnerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerMiddleName');
        }
        /** Data element ID "NAC". First Name or Given Name of the Owner. Hyphenated names acceptable, but no other use of special symbols. */
        get firstOwnerName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerName');
        }
        /** Data element ID "NAA". Name of the (or one of the) individual(s) who owns the Vehicle as defined in the ANSI D- 20 Data Element Dictionary. (Lastname@Firstname@MI@Suffix if any.) */
        get firstOwnerTotalName() {
            return this.document.fields.find((f) => f.type.name === 'FirstOwnerTotalName');
        }
        /** Data element ID "NAR". Street address line 1. (Mailing) */
        get mailingAddress1() {
            return this.document.fields.find((f) => f.type.name === 'MailingAddress1');
        }
        /** Data element ID "NAS". Street address line 2. (Mailing) */
        get mailingAddress2() {
            return this.document.fields.find((f) => f.type.name === 'MailingAddress2');
        }
        /** Data element ID "NAT". Name of city for mailing address. */
        get mailingCity() {
            return this.document.fields.find((f) => f.type.name === 'MailingCity');
        }
        /** Data element ID "NAU". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get mailingJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'MailingJurisdictionCode');
        }
        /** Data element ID "NAV". The ZIP code or Postal code used for mailing. (As used by Canadian, Mexican and US jurisdictions.) */
        get mailingZipCode() {
            return this.document.fields.find((f) => f.type.name === 'MailingZipCode');
        }
        /** Data element ID "NAM". Street address line 1. (Mailing) */
        get residenceAddress1() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceAddress1');
        }
        /** Data element ID "NAN". Street address line 2. (Mailing) */
        get residenceAddress2() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceAddress2');
        }
        /** Data element ID "NAO". Name of city for mailing address. */
        get residenceCity() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceCity');
        }
        /** Data element ID "NAP". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get residenceJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceJurisdictionCode');
        }
        /** Data element ID "NAQ". The ZIP code or Postal code used for mailing. (As used by Canadian, Mexican and US jurisdictions). */
        get residenceZipCode() {
            return this.document.fields.find((f) => f.type.name === 'ResidenceZipCode');
        }
        /** Data element ID "NAY". The unique customer number/ID of the second vehicle owner. */
        get secondOwnerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerIdNumber');
        }
        /** Data element ID "NAF". Last Name or Surname of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get secondOwnerLastName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerLastName');
        }
        /** Data element ID "NBB". The legal status of the second vehicle owner. This is only used when a vehicle has multiple owners. A legal status may be ("AND", "OR"). */
        get secondOwnerLegalStatus() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerLegalStatus');
        }
        /** Data element ID "NAH". Middle Name(s) or Initial(s) of the Owner. Hyphenated names acceptable, spaces between names acceptable, but no other use of special symbols. */
        get secondOwnerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerMiddleName');
        }
        /** Data element ID "NAG". First Name or Given Name of the Owner. Hyphenated names acceptable, but no other use of special symbols. */
        get secondOwnerName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerName');
        }
        /** Data element ID "NAE". Name of the (or one of the) individual(s) who owns the Vehicle as defined in the ANSI D- 20 Data Element Dictionary. (Lastname@Firstname@MI@Suffix if any.) */
        get secondOwnerTotalName() {
            return this.document.fields.find((f) => f.type.name === 'SecondOwnerTotalName');
        }
    }
    VehicleOwnerData.DOCUMENT_TYPE = 'VehicleOwnerData';
    VehicleOwnerData.FIRST_OWNER_ID_NUMBER_FIELD_NAME = 'FirstOwnerIdNumber';
    VehicleOwnerData.FIRST_OWNER_ID_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerIdNumber';
    VehicleOwnerData.FIRST_OWNER_LAST_NAME_FIELD_NAME = 'FirstOwnerLastName';
    VehicleOwnerData.FIRST_OWNER_LAST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerLastName';
    VehicleOwnerData.FIRST_OWNER_LEGAL_STATUS_FIELD_NAME = 'FirstOwnerLegalStatus';
    VehicleOwnerData.FIRST_OWNER_LEGAL_STATUS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerLegalStatus';
    VehicleOwnerData.FIRST_OWNER_MIDDLE_NAME_FIELD_NAME = 'FirstOwnerMiddleName';
    VehicleOwnerData.FIRST_OWNER_MIDDLE_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerMiddleName';
    VehicleOwnerData.FIRST_OWNER_NAME_FIELD_NAME = 'FirstOwnerName';
    VehicleOwnerData.FIRST_OWNER_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerName';
    VehicleOwnerData.FIRST_OWNER_TOTAL_NAME_FIELD_NAME = 'FirstOwnerTotalName';
    VehicleOwnerData.FIRST_OWNER_TOTAL_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.FirstOwnerTotalName';
    VehicleOwnerData.MAILING_ADDRESS_1_FIELD_NAME = 'MailingAddress1';
    VehicleOwnerData.MAILING_ADDRESS_1_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.MailingAddress1';
    VehicleOwnerData.MAILING_ADDRESS_2_FIELD_NAME = 'MailingAddress2';
    VehicleOwnerData.MAILING_ADDRESS_2_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.MailingAddress2';
    VehicleOwnerData.MAILING_CITY_FIELD_NAME = 'MailingCity';
    VehicleOwnerData.MAILING_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.MailingCity';
    VehicleOwnerData.MAILING_JURISDICTION_CODE_FIELD_NAME = 'MailingJurisdictionCode';
    VehicleOwnerData.MAILING_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.MailingJurisdictionCode';
    VehicleOwnerData.MAILING_ZIP_CODE_FIELD_NAME = 'MailingZipCode';
    VehicleOwnerData.MAILING_ZIP_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.MailingZipCode';
    VehicleOwnerData.RESIDENCE_ADDRESS_1_FIELD_NAME = 'ResidenceAddress1';
    VehicleOwnerData.RESIDENCE_ADDRESS_1_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.ResidenceAddress1';
    VehicleOwnerData.RESIDENCE_ADDRESS_2_FIELD_NAME = 'ResidenceAddress2';
    VehicleOwnerData.RESIDENCE_ADDRESS_2_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.ResidenceAddress2';
    VehicleOwnerData.RESIDENCE_CITY_FIELD_NAME = 'ResidenceCity';
    VehicleOwnerData.RESIDENCE_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.ResidenceCity';
    VehicleOwnerData.RESIDENCE_JURISDICTION_CODE_FIELD_NAME = 'ResidenceJurisdictionCode';
    VehicleOwnerData.RESIDENCE_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.ResidenceJurisdictionCode';
    VehicleOwnerData.RESIDENCE_ZIP_CODE_FIELD_NAME = 'ResidenceZipCode';
    VehicleOwnerData.RESIDENCE_ZIP_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.ResidenceZipCode';
    VehicleOwnerData.SECOND_OWNER_ID_NUMBER_FIELD_NAME = 'SecondOwnerIdNumber';
    VehicleOwnerData.SECOND_OWNER_ID_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerIdNumber';
    VehicleOwnerData.SECOND_OWNER_LAST_NAME_FIELD_NAME = 'SecondOwnerLastName';
    VehicleOwnerData.SECOND_OWNER_LAST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerLastName';
    VehicleOwnerData.SECOND_OWNER_LEGAL_STATUS_FIELD_NAME = 'SecondOwnerLegalStatus';
    VehicleOwnerData.SECOND_OWNER_LEGAL_STATUS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerLegalStatus';
    VehicleOwnerData.SECOND_OWNER_MIDDLE_NAME_FIELD_NAME = 'SecondOwnerMiddleName';
    VehicleOwnerData.SECOND_OWNER_MIDDLE_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerMiddleName';
    VehicleOwnerData.SECOND_OWNER_NAME_FIELD_NAME = 'SecondOwnerName';
    VehicleOwnerData.SECOND_OWNER_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerName';
    VehicleOwnerData.SECOND_OWNER_TOTAL_NAME_FIELD_NAME = 'SecondOwnerTotalName';
    VehicleOwnerData.SECOND_OWNER_TOTAL_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleOwnerData.SecondOwnerTotalName';
    AAMVA.VehicleOwnerData = VehicleOwnerData;
    /** Vehicle Data. File type "VH". */
    class VehicleData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.VehicleData.DOCUMENT_TYPE;
        }
        /** Data element ID "VAO". Vehicle manufacture body style. */
        get bodyStyle() {
            return this.document.fields.find((f) => f.type.name === 'BodyStyle');
        }
        /** Data element ID "VAG". Date vehicle reported junked. The format is ISO8601 with delimiters. */
        get dateJunked() {
            return this.document.fields.find((f) => f.type.name === 'DateJunked');
        }
        /** Data element ID "VAJ". Date vehicle reported recovered. The format is ISO8601 with delimiters. */
        get dateRecovered() {
            return this.document.fields.find((f) => f.type.name === 'DateRecovered');
        }
        /** Data element ID "VAI". Date vehicle reported stolen. The format is ISO8601 with delimiters. */
        get dateStolen() {
            return this.document.fields.find((f) => f.type.name === 'DateStolen');
        }
        /** Data element ID "VAW". Manufacturer’s rated engine displacement. */
        get engineDisplacement() {
            return this.document.fields.find((f) => f.type.name === 'EngineDisplacement');
        }
        /** Data element ID "VAR". The size of a vehicle’s engine. */
        get engineSize() {
            return this.document.fields.find((f) => f.type.name === 'EngineSize');
        }
        /** Data element ID "VAN". Type of fuel the vehicle utilizes. */
        get fuelType() {
            return this.document.fields.find((f) => f.type.name === 'FuelType');
        }
        /** Data element ID "VAU". Manufacturer’s rated horsepower. */
        get horsepower() {
            return this.document.fields.find((f) => f.type.name === 'Horsepower');
        }
        /** Data element ID "VAY". International fuel tax indicator */
        get iftaIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IFTAIndicator');
        }
        /** Data element ID "VAX". International registration plan indicator. */
        get irpIndicator() {
            return this.document.fields.find((f) => f.type.name === 'IRPIndicator');
        }
        /** Data element ID "VAF". Vehicle has been junked. */
        get junkedIndicator() {
            return this.document.fields.find((f) => f.type.name === 'JunkedIndicator');
        }
        /** Data element ID "VAE". Manufacturer’s Suggested Retail Price. No decimal places. Right Justified Zero or space fill. */
        get msrp() {
            return this.document.fields.find((f) => f.type.name === 'MSRP');
        }
        /** Data element ID "VAA". State to provide definition. */
        get majorCode() {
            return this.document.fields.find((f) => f.type.name === 'MajorCode');
        }
        /** Data element ID "VAL". Vehicle manufacture year. */
        get makeYear() {
            return this.document.fields.find((f) => f.type.name === 'MakeYear');
        }
        /** Data element ID "VAT". Manufacturer’s gross vehicle weight rating. */
        get manufactureGrossWeight() {
            return this.document.fields.find((f) => f.type.name === 'ManufactureGrossWeight');
        }
        /** Data element ID "VAB". State to provide definition. */
        get minorCode() {
            return this.document.fields.find((f) => f.type.name === 'MinorCode');
        }
        /** Data element ID "VBC". Number of axles the vehicle has. */
        get numberOfAxles() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfAxles');
        }
        /** Data element ID "VAQ". Number of cylinders the vehicle has. */
        get numberOfCylinders() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfCylinders');
        }
        /** Data element ID "VAP". Number of doors on the vehicle. */
        get numberOfDoors() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfDoors');
        }
        /** Data element ID "VAH". Indicates stolen vehicle. */
        get stolenIndicator() {
            return this.document.fields.find((f) => f.type.name === 'StolenIndicator');
        }
        /** Data element ID "VAC". Type of transmission the vehicle carries. */
        get transmissionCode() {
            return this.document.fields.find((f) => f.type.name === 'TransmissionCode');
        }
        /** Data element ID "VAV". Gross weight of the vehicle unloaded. */
        get unladenWeight() {
            return this.document.fields.find((f) => f.type.name === 'UnladenWeight');
        }
        /** Data element ID "VAZ". Vehicle license tax calculation from date of purchase. */
        get vltClacFromDate() {
            return this.document.fields.find((f) => f.type.name === 'VLTClacFromDate');
        }
        /** Data element ID "VBA". Unique number to identify the vehicle record. */
        get vehicleIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdNumber');
        }
        /** Data element ID "VAD". A unique combination of alphanumeric characters that identifies a specific vehicle or component. The VIN is affixed to the vehicle in specific locations and formulated by the manufacturer. State agencies under some controlled instances may assign a VIN to a vehicle. */
        get vehicleIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'VehicleIdentificationNumber');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAM". Vehicle manufacture model. */
        get vehicleModel() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModel');
        }
        /** Data element ID "VAS". This is the status of the vehicle (e.g., active, suspend, etc.) */
        get vehicleStatusCode() {
            return this.document.fields.find((f) => f.type.name === 'VehicleStatusCode');
        }
        /** Data element ID "VBB". EPA vehicle classification. */
        get vehicleTypeCode() {
            return this.document.fields.find((f) => f.type.name === 'VehicleTypeCode');
        }
    }
    VehicleData.DOCUMENT_TYPE = 'VehicleData';
    VehicleData.BODY_STYLE_FIELD_NAME = 'BodyStyle';
    VehicleData.BODY_STYLE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.BodyStyle';
    VehicleData.DATE_JUNKED_FIELD_NAME = 'DateJunked';
    VehicleData.DATE_JUNKED_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.DateJunked';
    VehicleData.DATE_RECOVERED_FIELD_NAME = 'DateRecovered';
    VehicleData.DATE_RECOVERED_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.DateRecovered';
    VehicleData.DATE_STOLEN_FIELD_NAME = 'DateStolen';
    VehicleData.DATE_STOLEN_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.DateStolen';
    VehicleData.ENGINE_DISPLACEMENT_FIELD_NAME = 'EngineDisplacement';
    VehicleData.ENGINE_DISPLACEMENT_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.EngineDisplacement';
    VehicleData.ENGINE_SIZE_FIELD_NAME = 'EngineSize';
    VehicleData.ENGINE_SIZE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.EngineSize';
    VehicleData.FUEL_TYPE_FIELD_NAME = 'FuelType';
    VehicleData.FUEL_TYPE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.FuelType';
    VehicleData.HORSEPOWER_FIELD_NAME = 'Horsepower';
    VehicleData.HORSEPOWER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.Horsepower';
    VehicleData.IFTA_INDICATOR_FIELD_NAME = 'IFTAIndicator';
    VehicleData.IFTA_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.IFTAIndicator';
    VehicleData.IRP_INDICATOR_FIELD_NAME = 'IRPIndicator';
    VehicleData.IRP_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.IRPIndicator';
    VehicleData.JUNKED_INDICATOR_FIELD_NAME = 'JunkedIndicator';
    VehicleData.JUNKED_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.JunkedIndicator';
    VehicleData.MSRP_FIELD_NAME = 'MSRP';
    VehicleData.MSRP_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.MSRP';
    VehicleData.MAJOR_CODE_FIELD_NAME = 'MajorCode';
    VehicleData.MAJOR_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.MajorCode';
    VehicleData.MAKE_YEAR_FIELD_NAME = 'MakeYear';
    VehicleData.MAKE_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.MakeYear';
    VehicleData.MANUFACTURE_GROSS_WEIGHT_FIELD_NAME = 'ManufactureGrossWeight';
    VehicleData.MANUFACTURE_GROSS_WEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.ManufactureGrossWeight';
    VehicleData.MINOR_CODE_FIELD_NAME = 'MinorCode';
    VehicleData.MINOR_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.MinorCode';
    VehicleData.NUMBER_OF_AXLES_FIELD_NAME = 'NumberOfAxles';
    VehicleData.NUMBER_OF_AXLES_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.NumberOfAxles';
    VehicleData.NUMBER_OF_CYLINDERS_FIELD_NAME = 'NumberOfCylinders';
    VehicleData.NUMBER_OF_CYLINDERS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.NumberOfCylinders';
    VehicleData.NUMBER_OF_DOORS_FIELD_NAME = 'NumberOfDoors';
    VehicleData.NUMBER_OF_DOORS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.NumberOfDoors';
    VehicleData.STOLEN_INDICATOR_FIELD_NAME = 'StolenIndicator';
    VehicleData.STOLEN_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.StolenIndicator';
    VehicleData.TRANSMISSION_CODE_FIELD_NAME = 'TransmissionCode';
    VehicleData.TRANSMISSION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.TransmissionCode';
    VehicleData.UNLADEN_WEIGHT_FIELD_NAME = 'UnladenWeight';
    VehicleData.UNLADEN_WEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.UnladenWeight';
    VehicleData.VLT_CLAC_FROM_DATE_FIELD_NAME = 'VLTClacFromDate';
    VehicleData.VLT_CLAC_FROM_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VLTClacFromDate';
    VehicleData.VEHICLE_ID_NUMBER_FIELD_NAME = 'VehicleIdNumber';
    VehicleData.VEHICLE_ID_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleIdNumber';
    VehicleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME = 'VehicleIdentificationNumber';
    VehicleData.VEHICLE_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleIdentificationNumber';
    VehicleData.VEHICLE_MAKE_FIELD_NAME = 'VehicleMake';
    VehicleData.VEHICLE_MAKE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleMake';
    VehicleData.VEHICLE_MODEL_FIELD_NAME = 'VehicleModel';
    VehicleData.VEHICLE_MODEL_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleModel';
    VehicleData.VEHICLE_STATUS_CODE_FIELD_NAME = 'VehicleStatusCode';
    VehicleData.VEHICLE_STATUS_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleStatusCode';
    VehicleData.VEHICLE_TYPE_CODE_FIELD_NAME = 'VehicleTypeCode';
    VehicleData.VEHICLE_TYPE_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleData.VehicleTypeCode';
    AAMVA.VehicleData = VehicleData;
    /** Vehicle Safety Inspection Data. File type "VS". */
    class VehicleSafetyInspectionData {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.VehicleSafetyInspectionData.DOCUMENT_TYPE;
        }
        /** Data element ID "IAN". The street name and number, city, state and zip code of the inspection facility. */
        get inspectionAddress() {
            return this.document.fields.find((f) => f.type.name === 'InspectionAddress');
        }
        /** Data element ID "IPD". Identifies whether the pollution control devices meet the minimum inspection criteria. */
        get inspectionAirPollutionDeviceConditions() {
            return this.document.fields.find((f) => f.type.name === 'InspectionAirPollutionDeviceConditions');
        }
        /** Data element ID "IFI". The unique number assigned to an inspection facility. */
        get inspectionFacilityIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFacilityIdentifier');
        }
        /** Data element ID "INC". A unique number assigned to a current vehicle inspection form for identification purposes or a preprinted unique number on the motor vehicle inspection sticker currently issued to a motor vehicle which has passed inspection. */
        get inspectionFormOrStickerNumberCurrent() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFormOrStickerNumberCurrent');
        }
        /** Data element ID "INP". The number of the last inspection form excluding the current inspection or the certification number of the last inspection sticker, excluding the current inspection. */
        get inspectionFormOrStickerNumberPrevious() {
            return this.document.fields.find((f) => f.type.name === 'InspectionFormOrStickerNumberPrevious');
        }
        /** Data element ID "ISC". An indicator that specifies whether or not the vehicle has a current smog certificate. */
        get inspectionSmogCertificateIndicator() {
            return this.document.fields.find((f) => f.type.name === 'InspectionSmogCertificateIndicator');
        }
        /** Data element ID "ISN". Station number performing the inspection. */
        get inspectionStationNumber() {
            return this.document.fields.find((f) => f.type.name === 'InspectionStationNumber');
        }
        /** Data element ID "IIN". A unique number assigned to each licensed vehicle inspector. */
        get inspectorIdentificationNumber() {
            return this.document.fields.find((f) => f.type.name === 'InspectorIdentificationNumber');
        }
        /** Data element ID "ORI". The vehicle’s odometer reading (to the nearest mile or kilometer) at the time of inspection. */
        get odometerReadingAtInspection() {
            return this.document.fields.find((f) => f.type.name === 'OdometerReadingAtInspection');
        }
        /** Data element ID "VAO". The general configuration or shape of a vehicle distinguished by characteristics such as number of doors, seats, windows, roofline, and type of top. The vehicle body type is 2- character alphanumeric. */
        get vehicleBodyType() {
            return this.document.fields.find((f) => f.type.name === 'VehicleBodyType');
        }
        /** Data element ID "VAK". The distinctive (coded) name applied to a group of vehicles by a manufacturer. */
        get vehicleMake() {
            return this.document.fields.find((f) => f.type.name === 'VehicleMake');
        }
        /** Data element ID "VAL". The year which is assigned to a vehicle by the manufacturer. The format is CCYY. */
        get vehicleModelYear() {
            return this.document.fields.find((f) => f.type.name === 'VehicleModelYear');
        }
    }
    VehicleSafetyInspectionData.DOCUMENT_TYPE = 'VehicleSafetyInspectionData';
    VehicleSafetyInspectionData.INSPECTION_ADDRESS_FIELD_NAME = 'InspectionAddress';
    VehicleSafetyInspectionData.INSPECTION_ADDRESS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionAddress';
    VehicleSafetyInspectionData.INSPECTION_AIR_POLLUTION_DEVICE_CONDITIONS_FIELD_NAME = 'InspectionAirPollutionDeviceConditions';
    VehicleSafetyInspectionData.INSPECTION_AIR_POLLUTION_DEVICE_CONDITIONS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionAirPollutionDeviceConditions';
    VehicleSafetyInspectionData.INSPECTION_FACILITY_IDENTIFIER_FIELD_NAME = 'InspectionFacilityIdentifier';
    VehicleSafetyInspectionData.INSPECTION_FACILITY_IDENTIFIER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionFacilityIdentifier';
    VehicleSafetyInspectionData.INSPECTION_FORM_OR_STICKER_NUMBER_CURRENT_FIELD_NAME = 'InspectionFormOrStickerNumberCurrent';
    VehicleSafetyInspectionData.INSPECTION_FORM_OR_STICKER_NUMBER_CURRENT_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionFormOrStickerNumberCurrent';
    VehicleSafetyInspectionData.INSPECTION_FORM_OR_STICKER_NUMBER_PREVIOUS_FIELD_NAME = 'InspectionFormOrStickerNumberPrevious';
    VehicleSafetyInspectionData.INSPECTION_FORM_OR_STICKER_NUMBER_PREVIOUS_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionFormOrStickerNumberPrevious';
    VehicleSafetyInspectionData.INSPECTION_SMOG_CERTIFICATE_INDICATOR_FIELD_NAME = 'InspectionSmogCertificateIndicator';
    VehicleSafetyInspectionData.INSPECTION_SMOG_CERTIFICATE_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionSmogCertificateIndicator';
    VehicleSafetyInspectionData.INSPECTION_STATION_NUMBER_FIELD_NAME = 'InspectionStationNumber';
    VehicleSafetyInspectionData.INSPECTION_STATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectionStationNumber';
    VehicleSafetyInspectionData.INSPECTOR_IDENTIFICATION_NUMBER_FIELD_NAME = 'InspectorIdentificationNumber';
    VehicleSafetyInspectionData.INSPECTOR_IDENTIFICATION_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.InspectorIdentificationNumber';
    VehicleSafetyInspectionData.ODOMETER_READING_AT_INSPECTION_FIELD_NAME = 'OdometerReadingAtInspection';
    VehicleSafetyInspectionData.ODOMETER_READING_AT_INSPECTION_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.OdometerReadingAtInspection';
    VehicleSafetyInspectionData.VEHICLE_BODY_TYPE_FIELD_NAME = 'VehicleBodyType';
    VehicleSafetyInspectionData.VEHICLE_BODY_TYPE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.VehicleBodyType';
    VehicleSafetyInspectionData.VEHICLE_MAKE_FIELD_NAME = 'VehicleMake';
    VehicleSafetyInspectionData.VEHICLE_MAKE_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.VehicleMake';
    VehicleSafetyInspectionData.VEHICLE_MODEL_YEAR_FIELD_NAME = 'VehicleModelYear';
    VehicleSafetyInspectionData.VEHICLE_MODEL_YEAR_FIELD_NAME_NORMALIZED = 'AAMVA.VehicleSafetyInspectionData.VehicleModelYear';
    AAMVA.VehicleSafetyInspectionData = VehicleSafetyInspectionData;
    /** Driver License Or ID Document */
    class DLID {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Data element ID "DAI". City portion of the cardholder address. */
        get addressCity() {
            return this.document.fields.find((f) => f.type.name === 'AddressCity');
        }
        /** Data element ID "DAJ". State portion of the cardholder address. */
        get addressJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressJurisdictionCode');
        }
        /** Data element ID "DAK". Postal code portion of the cardholder address in the U.S. and Canada. If the trailing portion of the postal code in the U.S. is not known, zeros will be used to fill the trailing set of numbers up to nine (9) digits. */
        get addressPostalCode() {
            return this.document.fields.find((f) => f.type.name === 'AddressPostalCode');
        }
        /** Data element ID "DAG". Street portion of the cardholder address. */
        get addressStreet1() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet1');
        }
        /** Data element ID "DAH". Second line of street portion of the cardholder address. */
        get addressStreet2() {
            return this.document.fields.find((f) => f.type.name === 'AddressStreet2');
        }
        /** Data element ID "DCJ". A string of letters and/or numbers that identifies when, where, and by whom a driver license/ID card was made. If audit information is not used on the card or the MRT, it must be included in the driver record. */
        get adultInformation() {
            return this.document.fields.find((f) => f.type.name === 'AdultInformation');
        }
        /** Data element ID "DBN". Other family name by which cardholder is known. */
        get aliasFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'AliasFamilyName');
        }
        /** Data element ID "DBG". Other given name by which cardholder is known. */
        get aliasGivenName() {
            return this.document.fields.find((f) => f.type.name === 'AliasGivenName');
        }
        /** Data element ID "DBQ". Other middle name by which cardholder is known. */
        get aliasMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'AliasMiddleName');
        }
        /** Data element ID "DBR". Other prefix by which cardholder is known. */
        get aliasPrefixName() {
            return this.document.fields.find((f) => f.type.name === 'AliasPrefixName');
        }
        /** Data element ID "DBS". Other suffix by which cardholder is known. */
        get aliasSuffixName() {
            return this.document.fields.find((f) => f.type.name === 'AliasSuffixName');
        }
        /** Data element ID "DDB". DHS required field that indicates date of the most recent version change or modification to the visible format of the DL/ID. The format is ISO8601 with delimiters. */
        get cardRevisionDate() {
            return this.document.fields.find((f) => f.type.name === 'CardRevisionDate');
        }
        /** Data element ID "DDA". DHS required field that indicates compliance: "F" = compliant; and, "N" = non-compliant. */
        get complianceType() {
            return this.document.fields.find((f) => f.type.name === 'ComplianceType');
        }
        /** Data element ID "DCG". Country in which DL/ID is issued. U.S. = USA, Canada = CAN. */
        get countryIdentification() {
            return this.document.fields.find((f) => f.type.name === 'CountryIdentification');
        }
        /** Data element ID "DCS". Family name of the cardholder. (Family name is sometimes also called “last name” or “surname.”) Collect full name for record, print as many characters as possible on portrait side of DL/ID. */
        get customerFamilyName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerFamilyName');
        }
        /** Data element ID "DAC". First name of the cardholder. */
        get customerFirstName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerFirstName');
        }
        /** Data element ID "DCT". Given names of the cardholder. (Given names include all names other than the Family Name. This includes all those names sometimes also called “first” and “middle” names.) */
        get customerGivenNames() {
            return this.document.fields.find((f) => f.type.name === 'CustomerGivenNames');
        }
        /** Data element ID "DAQ". The number assigned or calculated by the issuing authority. */
        get customerIdNumber() {
            return this.document.fields.find((f) => f.type.name === 'CustomerIdNumber');
        }
        /** Data element ID "DAD". Middle name(s) of the cardholder. In the case of multiple middle names they shall be separated by a comma “,”. */
        get customerMiddleName() {
            return this.document.fields.find((f) => f.type.name === 'CustomerMiddleName');
        }
        /** Data element ID "DBB". Date on which the cardholder was born. The format is ISO8601 with delimiters. */
        get dateOfBirth() {
            return this.document.fields.find((f) => f.type.name === 'DateOfBirth');
        }
        /** Data element ID "DCF". Number must uniquely identify a particular document issued to that customer from others that may have been issued in the past. This number may serve multiple purposes of document discrimination, audit information number, and/or inventory control. */
        get documentDiscriminator() {
            return this.document.fields.find((f) => f.type.name === 'DocumentDiscriminator');
        }
        /** Data element ID "DBA". Date on which the driving and identification privileges granted by the document are no longer valid. The format is ISO8601 with delimtiers. */
        get documentExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'DocumentExpirationDate');
        }
        /** Data element ID "DBD". Date on which the document was issued. The format is ISO8601 with delimiters. */
        get documentIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'DocumentIssueDate');
        }
        /** Data element ID "DBL". Alternative dates given as date of birth. */
        get driverAliasDateOfBirthField() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasDateOfBirthField');
        }
        /** Data element ID "DBP". Alternative fist name or given name of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverAliasFirstName() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasFirstName');
        }
        /** Data element ID "DBO". Alternative last name or surname of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverAliasLastName() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasLastName');
        }
        /** Data element ID "DBM". DriverAliasSocialSecurityNumber */
        get driverAliasSocialSecurityNumber() {
            return this.document.fields.find((f) => f.type.name === 'DriverAliasSocialSecurityNumber');
        }
        /** Data element ID "DAB". Last name or surname of the individual holding the Driver License or ID. Hyphenated names acceptable, but no other use of special symbols. */
        get driverLastName() {
            return this.document.fields.find((f) => f.type.name === 'DriverLastName');
        }
        /** Data element ID "DAR". A=Class A; B=Class B; C=Class C (Class A, B and C are defined by Federal Highway regulations); M=Class M motorcycle as defined by AAMVA; others are defined by DL Classification Code Standards. */
        get driverLicenseClassificationCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseClassificationCode');
        }
        /** Data element ID "DAT". Any endorsements on a driver license which authorize the operation of specified types of vehicles or the operation of vehicles carrying specified loads. Endorsements shall be specific to classification of a driver license. */
        get driverLicenseEndorsementsCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseEndorsementsCode');
        }
        /** Data element ID "DAA". Name of the individual holding the Driver License or ID as defined in ANSI D20 Data Dictionary. (Lastname@Firstname@MI@ suffix if any) (Machine, Mag Stripe uses ‘$’ and Bar Code uses ‘,’ in place of ‘@’) Firstname, Middle Initial, Lastname (Human) */
        get driverLicenseName() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseName');
        }
        /** Data element ID "DAS". A restriction applicable to a driver license. */
        get driverLicenseRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverLicenseRestrictionCode');
        }
        /** Data element ID "DAF". Prefix to Driver Name. Not defined in ANSI D20. Freeform as defined by issuing jurisdiction. */
        get driverNamePrefix() {
            return this.document.fields.find((f) => f.type.name === 'DriverNamePrefix');
        }
        /** Data element ID "DAE". An affix occurring at the end of a word, e.g.; Sr., Jr., II, III, IV, etc. */
        get driverNameSuffix() {
            return this.document.fields.find((f) => f.type.name === 'DriverNameSuffix');
        }
        /** Data element ID "PAA". Identifies the type of permit as defined by ANSI D20. */
        get driverPermitClassificationCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitClassificationCode');
        }
        /** Data element ID "PAF". Permit endorsements as defined by ANSI D20. */
        get driverPermitEndorsementCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitEndorsementCode');
        }
        /** Data element ID "PAD".  Date permit was issued. The format is ISO8601 with delimiters. */
        get driverPermitIssueDate() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitIssueDate');
        }
        /** Data element ID "PAE". Permit restrictions as defined by ANSI D20. */
        get driverPermitRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverPermitRestrictionCode');
        }
        /** Data element ID "DAN". Name of city for mailing address. */
        get driverResidenceCity() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceCity');
        }
        /** Data element ID "DAO". Jurisdiction code for mailing address. Conforms to Canadian, Mexican and US Jurisdictions as appropriate. Codes for provinces (Canada) and states (US and Mexico). */
        get driverResidenceJurisdictionCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceJurisdictionCode');
        }
        /** Data element ID "DAP". Postal code of residence */
        get driverResidencePostalCode() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidencePostalCode');
        }
        /** Data element ID "DAL". Street address line 1 (mailing). */
        get driverResidenceStreetAddress1() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceStreetAddress1');
        }
        /** Data element ID "DAM". Street address line 2 (mailing). */
        get driverResidenceStreetAddress2() {
            return this.document.fields.find((f) => f.type.name === 'DriverResidenceStreetAddress2');
        }
        /** Data element ID "DDE". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get familyNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'FamilyNameTruncation');
        }
        /** Data element ID "DCH". Federal Commercial Vehicle Codes */
        get federalCommercialVehicleCodes() {
            return this.document.fields.find((f) => f.type.name === 'FederalCommercialVehicleCodes');
        }
        /** Data element ID "DDF". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get firstNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'FirstNameTruncation');
        }
        /** Data element ID "DDC". Date on which the hazardous material endorsement granted by the document is no longer valid. The format is ISO8601 with delimiters. */
        get hazmatEndorsementExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'HAZMATEndorsementExpirationDate');
        }
        /** Data element ID "DAZ". Color of cardholder's hair. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get hairColor() {
            return this.document.fields.find((f) => f.type.name === 'HairColor');
        }
        /** Data element ID "DAV". Height in centimeters */
        get height() {
            return this.document.fields.find((f) => f.type.name === 'Height');
        }
        /** Data element ID "DCK". A string of letters and/or numbers that is affixed to the raw materials (card stock, laminate, etc.) used in producing driver licenses and ID cards. (DHS recommended field). */
        get inventoryControlNumber() {
            return this.document.fields.find((f) => f.type.name === 'InventoryControlNumber');
        }
        /** Data element ID "DBE". A string used by some jurisdictions to validate the document against their data base. */
        get issueTimeStamp() {
            return this.document.fields.find((f) => f.type.name === 'IssueTimeStamp');
        }
        /** Data element ID "DCQ". Text that explains the jurisdiction-specific code(s) that indicates additional driving privileges granted to the cardholder beyond the vehicle class. */
        get jurisdictionSpecificEndorsementCodeDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificEndorsementCodeDescription');
        }
        /** Data element ID "DCD". Jurisdiction-specific codes that represent additional privileges granted to the cardholder beyond the vehicle class (such as transportation of passengers, hazardous materials, operation of motorcycles, etc.). */
        get jurisdictionSpecificEndorsementCodes() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificEndorsementCodes');
        }
        /** Data element ID "DCR". Text describing the jurisdiction-specific restriction code(s) that curtail driving privileges. */
        get jurisdictionSpecificRestrictionCodeDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificRestrictionCodeDescription');
        }
        /** Data element ID "DCB". Jurisdiction-specific codes that represent restrictions to driving privileges (such as airbrakes, automatic transmission, daylight only, etc.). */
        get jurisdictionSpecificRestrictionCodes() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificRestrictionCodes');
        }
        /** Data element ID "DCA". Jurisdiction-specific vehicle class / group code, designating the type of vehicle the cardholder has privilege to drive. */
        get jurisdictionSpecificVehicleClass() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificVehicleClass');
        }
        /** Data element ID "DCP". Text that explains the jurisdiction-specific code(s) for classifications of vehicles cardholder is authorized to drive. */
        get jurisdictionSpecificVehicleClassificationDescription() {
            return this.document.fields.find((f) => f.type.name === 'JurisdictionSpecificVehicleClassificationDescription');
        }
        /** Data element ID "DDD". DHS required field that indicates that the cardholder has temporary lawful status = "1". */
        get limitedDurationDocumentIndicator() {
            return this.document.fields.find((f) => f.type.name === 'LimitedDurationDocumentIndicator');
        }
        /** Data element ID "DDG". A code that indicates whether a field has been truncated (T), has not been truncated (N), or – unknown whether truncated (U). */
        get middleNameTruncation() {
            return this.document.fields.find((f) => f.type.name === 'MiddleNameTruncation');
        }
        /** Data element ID "DCU". Name Suffix (If jurisdiction participates in systems requiring name suffix (PDPS, CDLIS, etc.), the suffix must be collected and displayed on the DL/ID and in the MRT). Collect full name for record, print as many characters as possible on portrait side of DL/ID. JR (Junior), SR (Senior), 1ST or I (First), 2ND or II (Second),  3RD or III (Third),  4TH or IV (Fourth), 5TH or V (Fifth), 6TH or VI (Sixth), 7TH or VII (Seventh), 8TH or VIII (Eighth), 9TH or IX (Ninth). */
        get nameSuffix() {
            return this.document.fields.find((f) => f.type.name === 'NameSuffix');
        }
        /** Data element ID "DBI". "Y"; Used by some jurisdictions to indicate holder of the document is a non-resident. */
        get nonResidentIndicator() {
            return this.document.fields.find((f) => f.type.name === 'NonResidentIndicator');
        }
        /** Data element ID "DBF". Number of duplicate cards issued for a license or ID if any. */
        get numberOfDuplicates() {
            return this.document.fields.find((f) => f.type.name === 'NumberOfDuplicates');
        }
        /** Data element ID "DBH". Organ Donor */
        get organDonor() {
            return this.document.fields.find((f) => f.type.name === 'OrganDonor');
        }
        /** Data element ID "DDK". Field that indicates that the cardholder is an organ donor = "1". */
        get organDonorIndicator() {
            return this.document.fields.find((f) => f.type.name === 'OrganDonorIndicator');
        }
        /** Data element ID "PAB". Date permit expires, The format is ISO8601 with delimiters. */
        get permitExpirationDate() {
            return this.document.fields.find((f) => f.type.name === 'PermitExpirationDate');
        }
        /** Data element ID "PAC". Type of permit. */
        get permitIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'PermitIdentifier');
        }
        /** Data element ID "DAY". Color of cardholder's eyes. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get physicalDescriptionEyeColor() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionEyeColor');
        }
        /** Data element ID "DAU". Height of cardholder. Inches (in): number of inches followed by " in" or Centimeters (cm): number of centimeters followed by " cm." */
        get physicalDescriptionHeight() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionHeight');
        }
        /** Data element ID "DBC". Gender of the cardholder. "Male" or "Female". */
        get physicalDescriptionSex() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionSex');
        }
        /** Data element ID "DCE". Indicates the approximate weight range of the cardholder: 0 = up to 31 kg (up to 70 lbs), 1 = 32 – 45 kg (71 – 100 lbs), 2 = 46 - 59 kg (101 – 130 lbs), 3 = 60 - 70 kg (131 – 160 lbs), 4 = 71 - 86 kg (161 – 190 lbs), 5 = 87 - 100 kg (191 – 220 lbs), 6 = 101 - 113 kg (221 – 250 lbs), 7 = 114 - 127 kg (251 – 280 lbs), 8 = 128 – 145 kg (281 – 320 lbs), 9 = 146+ kg (321+ lbs). */
        get physicalDescriptionWeightRange() {
            return this.document.fields.find((f) => f.type.name === 'PhysicalDescriptionWeightRange');
        }
        /** Data element ID "DCI". Country and municipality and/or state/province. */
        get placeOfBirth() {
            return this.document.fields.find((f) => f.type.name === 'PlaceOfBirth');
        }
        /** Data element ID "DCL". Codes for race or ethnicity of the cardholder. ANSI D-20 codes converted to human readable format according to the ANSI D20 Data Dictionary. */
        get raceEthnicity() {
            return this.document.fields.find((f) => f.type.name === 'RaceEthnicity');
        }
        /** Data element ID "DBK". The number assigned to an individual by the Social Security Administration. */
        get socialSecurityNumber() {
            return this.document.fields.find((f) => f.type.name === 'SocialSecurityNumber');
        }
        /** Data element ID "DCN". Standard endorsement code(s) for cardholder. See codes in D20. This data element is a placeholder for future efforts to standardize endorsement codes. */
        get standardEndorsementCode() {
            return this.document.fields.find((f) => f.type.name === 'StandardEndorsementCode');
        }
        /** Data element ID "DCO". Standard restriction code(s) for cardholder. See codes in D20. This data element is a placeholder for future efforts to standardize restriction codes. */
        get standardRestrictionCode() {
            return this.document.fields.find((f) => f.type.name === 'StandardRestrictionCode');
        }
        /** Data element ID "DCM". Standard vehicle classification code(s) for cardholder. This data element is a placeholder for future efforts to standardize vehicle classifications. */
        get standardVehicleClassification() {
            return this.document.fields.find((f) => f.type.name === 'StandardVehicleClassification');
        }
        /** Data element ID "DDH". Date on which the cardholder turns 18 years old. The format is ISO8601 with delimiters. */
        get under18Until() {
            return this.document.fields.find((f) => f.type.name === 'Under18Until');
        }
        /** Data element ID "DDI". Date on which the cardholder turns 19 years old. The format is ISO8601 with delimiters. */
        get under19Until() {
            return this.document.fields.find((f) => f.type.name === 'Under19Until');
        }
        /** Data element ID "DDJ". Date on which the cardholder turns 21 years old. The format is ISO8601 with delimiters. */
        get under21Until() {
            return this.document.fields.find((f) => f.type.name === 'Under21Until');
        }
        /** Data element ID "DBJ". A number or alphanumeric string used by some jurisdictions to identify a "customer" across multiple data bases. */
        get uniqueCustomerIdentifier() {
            return this.document.fields.find((f) => f.type.name === 'UniqueCustomerIdentifier');
        }
        /** Data element ID "DDL". Field that indicates that the cardholder is a veteran = "1". */
        get veteranIndicator() {
            return this.document.fields.find((f) => f.type.name === 'VeteranIndicator');
        }
        /** Data element ID "DAX". Cardholder weight in kilograms Ex. 84 kg = "084" */
        get weightKilograms() {
            return this.document.fields.find((f) => f.type.name === 'WeightKilograms');
        }
        /** Data element ID "DAW". Cardholder weight in pounds Ex. 185 lb = "185" */
        get weightPounds() {
            return this.document.fields.find((f) => f.type.name === 'WeightPounds');
        }
    }
    DLID.ADDRESS_CITY_FIELD_NAME = 'AddressCity';
    DLID.ADDRESS_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AddressCity';
    DLID.ADDRESS_JURISDICTION_CODE_FIELD_NAME = 'AddressJurisdictionCode';
    DLID.ADDRESS_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AddressJurisdictionCode';
    DLID.ADDRESS_POSTAL_CODE_FIELD_NAME = 'AddressPostalCode';
    DLID.ADDRESS_POSTAL_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AddressPostalCode';
    DLID.ADDRESS_STREET_1_FIELD_NAME = 'AddressStreet1';
    DLID.ADDRESS_STREET_1_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AddressStreet1';
    DLID.ADDRESS_STREET_2_FIELD_NAME = 'AddressStreet2';
    DLID.ADDRESS_STREET_2_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AddressStreet2';
    DLID.ADULT_INFORMATION_FIELD_NAME = 'AdultInformation';
    DLID.ADULT_INFORMATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AdultInformation';
    DLID.ALIAS_FAMILY_NAME_FIELD_NAME = 'AliasFamilyName';
    DLID.ALIAS_FAMILY_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AliasFamilyName';
    DLID.ALIAS_GIVEN_NAME_FIELD_NAME = 'AliasGivenName';
    DLID.ALIAS_GIVEN_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AliasGivenName';
    DLID.ALIAS_MIDDLE_NAME_FIELD_NAME = 'AliasMiddleName';
    DLID.ALIAS_MIDDLE_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AliasMiddleName';
    DLID.ALIAS_PREFIX_NAME_FIELD_NAME = 'AliasPrefixName';
    DLID.ALIAS_PREFIX_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AliasPrefixName';
    DLID.ALIAS_SUFFIX_NAME_FIELD_NAME = 'AliasSuffixName';
    DLID.ALIAS_SUFFIX_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.AliasSuffixName';
    DLID.CARD_REVISION_DATE_FIELD_NAME = 'CardRevisionDate';
    DLID.CARD_REVISION_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CardRevisionDate';
    DLID.COMPLIANCE_TYPE_FIELD_NAME = 'ComplianceType';
    DLID.COMPLIANCE_TYPE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.ComplianceType';
    DLID.COUNTRY_IDENTIFICATION_FIELD_NAME = 'CountryIdentification';
    DLID.COUNTRY_IDENTIFICATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CountryIdentification';
    DLID.CUSTOMER_FAMILY_NAME_FIELD_NAME = 'CustomerFamilyName';
    DLID.CUSTOMER_FAMILY_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CustomerFamilyName';
    DLID.CUSTOMER_FIRST_NAME_FIELD_NAME = 'CustomerFirstName';
    DLID.CUSTOMER_FIRST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CustomerFirstName';
    DLID.CUSTOMER_GIVEN_NAMES_FIELD_NAME = 'CustomerGivenNames';
    DLID.CUSTOMER_GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CustomerGivenNames';
    DLID.CUSTOMER_ID_NUMBER_FIELD_NAME = 'CustomerIdNumber';
    DLID.CUSTOMER_ID_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CustomerIdNumber';
    DLID.CUSTOMER_MIDDLE_NAME_FIELD_NAME = 'CustomerMiddleName';
    DLID.CUSTOMER_MIDDLE_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.CustomerMiddleName';
    DLID.DATE_OF_BIRTH_FIELD_NAME = 'DateOfBirth';
    DLID.DATE_OF_BIRTH_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DateOfBirth';
    DLID.DOCUMENT_DISCRIMINATOR_FIELD_NAME = 'DocumentDiscriminator';
    DLID.DOCUMENT_DISCRIMINATOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DocumentDiscriminator';
    DLID.DOCUMENT_EXPIRATION_DATE_FIELD_NAME = 'DocumentExpirationDate';
    DLID.DOCUMENT_EXPIRATION_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DocumentExpirationDate';
    DLID.DOCUMENT_ISSUE_DATE_FIELD_NAME = 'DocumentIssueDate';
    DLID.DOCUMENT_ISSUE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DocumentIssueDate';
    DLID.DRIVER_ALIAS_DATE_OF_BIRTH_FIELD_FIELD_NAME = 'DriverAliasDateOfBirthField';
    DLID.DRIVER_ALIAS_DATE_OF_BIRTH_FIELD_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverAliasDateOfBirthField';
    DLID.DRIVER_ALIAS_FIRST_NAME_FIELD_NAME = 'DriverAliasFirstName';
    DLID.DRIVER_ALIAS_FIRST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverAliasFirstName';
    DLID.DRIVER_ALIAS_LAST_NAME_FIELD_NAME = 'DriverAliasLastName';
    DLID.DRIVER_ALIAS_LAST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverAliasLastName';
    DLID.DRIVER_ALIAS_SOCIAL_SECURITY_NUMBER_FIELD_NAME = 'DriverAliasSocialSecurityNumber';
    DLID.DRIVER_ALIAS_SOCIAL_SECURITY_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverAliasSocialSecurityNumber';
    DLID.DRIVER_LAST_NAME_FIELD_NAME = 'DriverLastName';
    DLID.DRIVER_LAST_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverLastName';
    DLID.DRIVER_LICENSE_CLASSIFICATION_CODE_FIELD_NAME = 'DriverLicenseClassificationCode';
    DLID.DRIVER_LICENSE_CLASSIFICATION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverLicenseClassificationCode';
    DLID.DRIVER_LICENSE_ENDORSEMENTS_CODE_FIELD_NAME = 'DriverLicenseEndorsementsCode';
    DLID.DRIVER_LICENSE_ENDORSEMENTS_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverLicenseEndorsementsCode';
    DLID.DRIVER_LICENSE_NAME_FIELD_NAME = 'DriverLicenseName';
    DLID.DRIVER_LICENSE_NAME_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverLicenseName';
    DLID.DRIVER_LICENSE_RESTRICTION_CODE_FIELD_NAME = 'DriverLicenseRestrictionCode';
    DLID.DRIVER_LICENSE_RESTRICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverLicenseRestrictionCode';
    DLID.DRIVER_NAME_PREFIX_FIELD_NAME = 'DriverNamePrefix';
    DLID.DRIVER_NAME_PREFIX_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverNamePrefix';
    DLID.DRIVER_NAME_SUFFIX_FIELD_NAME = 'DriverNameSuffix';
    DLID.DRIVER_NAME_SUFFIX_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverNameSuffix';
    DLID.DRIVER_PERMIT_CLASSIFICATION_CODE_FIELD_NAME = 'DriverPermitClassificationCode';
    DLID.DRIVER_PERMIT_CLASSIFICATION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverPermitClassificationCode';
    DLID.DRIVER_PERMIT_ENDORSEMENT_CODE_FIELD_NAME = 'DriverPermitEndorsementCode';
    DLID.DRIVER_PERMIT_ENDORSEMENT_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverPermitEndorsementCode';
    DLID.DRIVER_PERMIT_ISSUE_DATE_FIELD_NAME = 'DriverPermitIssueDate';
    DLID.DRIVER_PERMIT_ISSUE_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverPermitIssueDate';
    DLID.DRIVER_PERMIT_RESTRICTION_CODE_FIELD_NAME = 'DriverPermitRestrictionCode';
    DLID.DRIVER_PERMIT_RESTRICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverPermitRestrictionCode';
    DLID.DRIVER_RESIDENCE_CITY_FIELD_NAME = 'DriverResidenceCity';
    DLID.DRIVER_RESIDENCE_CITY_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverResidenceCity';
    DLID.DRIVER_RESIDENCE_JURISDICTION_CODE_FIELD_NAME = 'DriverResidenceJurisdictionCode';
    DLID.DRIVER_RESIDENCE_JURISDICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverResidenceJurisdictionCode';
    DLID.DRIVER_RESIDENCE_POSTAL_CODE_FIELD_NAME = 'DriverResidencePostalCode';
    DLID.DRIVER_RESIDENCE_POSTAL_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverResidencePostalCode';
    DLID.DRIVER_RESIDENCE_STREET_ADDRESS_1_FIELD_NAME = 'DriverResidenceStreetAddress1';
    DLID.DRIVER_RESIDENCE_STREET_ADDRESS_1_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverResidenceStreetAddress1';
    DLID.DRIVER_RESIDENCE_STREET_ADDRESS_2_FIELD_NAME = 'DriverResidenceStreetAddress2';
    DLID.DRIVER_RESIDENCE_STREET_ADDRESS_2_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.DriverResidenceStreetAddress2';
    DLID.FAMILY_NAME_TRUNCATION_FIELD_NAME = 'FamilyNameTruncation';
    DLID.FAMILY_NAME_TRUNCATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.FamilyNameTruncation';
    DLID.FEDERAL_COMMERCIAL_VEHICLE_CODES_FIELD_NAME = 'FederalCommercialVehicleCodes';
    DLID.FEDERAL_COMMERCIAL_VEHICLE_CODES_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.FederalCommercialVehicleCodes';
    DLID.FIRST_NAME_TRUNCATION_FIELD_NAME = 'FirstNameTruncation';
    DLID.FIRST_NAME_TRUNCATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.FirstNameTruncation';
    DLID.HAZMAT_ENDORSEMENT_EXPIRATION_DATE_FIELD_NAME = 'HAZMATEndorsementExpirationDate';
    DLID.HAZMAT_ENDORSEMENT_EXPIRATION_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.HAZMATEndorsementExpirationDate';
    DLID.HAIR_COLOR_FIELD_NAME = 'HairColor';
    DLID.HAIR_COLOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.HairColor';
    DLID.HEIGHT_FIELD_NAME = 'Height';
    DLID.HEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.Height';
    DLID.INVENTORY_CONTROL_NUMBER_FIELD_NAME = 'InventoryControlNumber';
    DLID.INVENTORY_CONTROL_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.InventoryControlNumber';
    DLID.ISSUE_TIME_STAMP_FIELD_NAME = 'IssueTimeStamp';
    DLID.ISSUE_TIME_STAMP_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.IssueTimeStamp';
    DLID.JURISDICTION_SPECIFIC_ENDORSEMENT_CODE_DESCRIPTION_FIELD_NAME = 'JurisdictionSpecificEndorsementCodeDescription';
    DLID.JURISDICTION_SPECIFIC_ENDORSEMENT_CODE_DESCRIPTION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificEndorsementCodeDescription';
    DLID.JURISDICTION_SPECIFIC_ENDORSEMENT_CODES_FIELD_NAME = 'JurisdictionSpecificEndorsementCodes';
    DLID.JURISDICTION_SPECIFIC_ENDORSEMENT_CODES_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificEndorsementCodes';
    DLID.JURISDICTION_SPECIFIC_RESTRICTION_CODE_DESCRIPTION_FIELD_NAME = 'JurisdictionSpecificRestrictionCodeDescription';
    DLID.JURISDICTION_SPECIFIC_RESTRICTION_CODE_DESCRIPTION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificRestrictionCodeDescription';
    DLID.JURISDICTION_SPECIFIC_RESTRICTION_CODES_FIELD_NAME = 'JurisdictionSpecificRestrictionCodes';
    DLID.JURISDICTION_SPECIFIC_RESTRICTION_CODES_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificRestrictionCodes';
    DLID.JURISDICTION_SPECIFIC_VEHICLE_CLASS_FIELD_NAME = 'JurisdictionSpecificVehicleClass';
    DLID.JURISDICTION_SPECIFIC_VEHICLE_CLASS_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificVehicleClass';
    DLID.JURISDICTION_SPECIFIC_VEHICLE_CLASSIFICATION_DESCRIPTION_FIELD_NAME = 'JurisdictionSpecificVehicleClassificationDescription';
    DLID.JURISDICTION_SPECIFIC_VEHICLE_CLASSIFICATION_DESCRIPTION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.JurisdictionSpecificVehicleClassificationDescription';
    DLID.LIMITED_DURATION_DOCUMENT_INDICATOR_FIELD_NAME = 'LimitedDurationDocumentIndicator';
    DLID.LIMITED_DURATION_DOCUMENT_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.LimitedDurationDocumentIndicator';
    DLID.MIDDLE_NAME_TRUNCATION_FIELD_NAME = 'MiddleNameTruncation';
    DLID.MIDDLE_NAME_TRUNCATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.MiddleNameTruncation';
    DLID.NAME_SUFFIX_FIELD_NAME = 'NameSuffix';
    DLID.NAME_SUFFIX_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.NameSuffix';
    DLID.NON_RESIDENT_INDICATOR_FIELD_NAME = 'NonResidentIndicator';
    DLID.NON_RESIDENT_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.NonResidentIndicator';
    DLID.NUMBER_OF_DUPLICATES_FIELD_NAME = 'NumberOfDuplicates';
    DLID.NUMBER_OF_DUPLICATES_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.NumberOfDuplicates';
    DLID.ORGAN_DONOR_FIELD_NAME = 'OrganDonor';
    DLID.ORGAN_DONOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.OrganDonor';
    DLID.ORGAN_DONOR_INDICATOR_FIELD_NAME = 'OrganDonorIndicator';
    DLID.ORGAN_DONOR_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.OrganDonorIndicator';
    DLID.PERMIT_EXPIRATION_DATE_FIELD_NAME = 'PermitExpirationDate';
    DLID.PERMIT_EXPIRATION_DATE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PermitExpirationDate';
    DLID.PERMIT_IDENTIFIER_FIELD_NAME = 'PermitIdentifier';
    DLID.PERMIT_IDENTIFIER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PermitIdentifier';
    DLID.PHYSICAL_DESCRIPTION_EYE_COLOR_FIELD_NAME = 'PhysicalDescriptionEyeColor';
    DLID.PHYSICAL_DESCRIPTION_EYE_COLOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PhysicalDescriptionEyeColor';
    DLID.PHYSICAL_DESCRIPTION_HEIGHT_FIELD_NAME = 'PhysicalDescriptionHeight';
    DLID.PHYSICAL_DESCRIPTION_HEIGHT_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PhysicalDescriptionHeight';
    DLID.PHYSICAL_DESCRIPTION_SEX_FIELD_NAME = 'PhysicalDescriptionSex';
    DLID.PHYSICAL_DESCRIPTION_SEX_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PhysicalDescriptionSex';
    DLID.PHYSICAL_DESCRIPTION_WEIGHT_RANGE_FIELD_NAME = 'PhysicalDescriptionWeightRange';
    DLID.PHYSICAL_DESCRIPTION_WEIGHT_RANGE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PhysicalDescriptionWeightRange';
    DLID.PLACE_OF_BIRTH_FIELD_NAME = 'PlaceOfBirth';
    DLID.PLACE_OF_BIRTH_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.PlaceOfBirth';
    DLID.RACE_ETHNICITY_FIELD_NAME = 'RaceEthnicity';
    DLID.RACE_ETHNICITY_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.RaceEthnicity';
    DLID.SOCIAL_SECURITY_NUMBER_FIELD_NAME = 'SocialSecurityNumber';
    DLID.SOCIAL_SECURITY_NUMBER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.SocialSecurityNumber';
    DLID.STANDARD_ENDORSEMENT_CODE_FIELD_NAME = 'StandardEndorsementCode';
    DLID.STANDARD_ENDORSEMENT_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.StandardEndorsementCode';
    DLID.STANDARD_RESTRICTION_CODE_FIELD_NAME = 'StandardRestrictionCode';
    DLID.STANDARD_RESTRICTION_CODE_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.StandardRestrictionCode';
    DLID.STANDARD_VEHICLE_CLASSIFICATION_FIELD_NAME = 'StandardVehicleClassification';
    DLID.STANDARD_VEHICLE_CLASSIFICATION_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.StandardVehicleClassification';
    DLID.UNDER_18_UNTIL_FIELD_NAME = 'Under18Until';
    DLID.UNDER_18_UNTIL_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.Under18Until';
    DLID.UNDER_19_UNTIL_FIELD_NAME = 'Under19Until';
    DLID.UNDER_19_UNTIL_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.Under19Until';
    DLID.UNDER_21_UNTIL_FIELD_NAME = 'Under21Until';
    DLID.UNDER_21_UNTIL_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.Under21Until';
    DLID.UNIQUE_CUSTOMER_IDENTIFIER_FIELD_NAME = 'UniqueCustomerIdentifier';
    DLID.UNIQUE_CUSTOMER_IDENTIFIER_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.UniqueCustomerIdentifier';
    DLID.VETERAN_INDICATOR_FIELD_NAME = 'VeteranIndicator';
    DLID.VETERAN_INDICATOR_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.VeteranIndicator';
    DLID.WEIGHT_KILOGRAMS_FIELD_NAME = 'WeightKilograms';
    DLID.WEIGHT_KILOGRAMS_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.WeightKilograms';
    DLID.WEIGHT_POUNDS_FIELD_NAME = 'WeightPounds';
    DLID.WEIGHT_POUNDS_FIELD_NAME_NORMALIZED = 'AAMVA.DLID.WeightPounds';
    AAMVA.DLID = DLID;
    /** Driver License. File type "DL". */
    class DriverLicense extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVA.DriverLicense.DOCUMENT_TYPE;
        }
    }
    DriverLicense.DOCUMENT_TYPE = 'DriverLicense';
    AAMVA.DriverLicense = DriverLicense;
    /** ID Card. File type "ID". */
    class IDCard extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVA.IDCard.DOCUMENT_TYPE;
        }
    }
    IDCard.DOCUMENT_TYPE = 'IDCard';
    AAMVA.IDCard = IDCard;
    /** Enhanced Driver License. File type "EN". */
    class EnhancedDriverLicense extends DLID {
        constructor(document) {
            super(document);
        }
        requiredDocumentType() {
            return AAMVA.EnhancedDriverLicense.DOCUMENT_TYPE;
        }
    }
    EnhancedDriverLicense.DOCUMENT_TYPE = 'EnhancedDriverLicense';
    AAMVA.EnhancedDriverLicense = EnhancedDriverLicense;
    /** The raw document as was parsed from the barcode. The original field key names and field values as they appear in the barcode are left as-is. The mnemonic field keys from the AAMVA specification are not replaced with human-readable names. No field value normalization, like ISO 8601 date reformatting, etc., is done. */
    class RawDocument {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return AAMVA.RawDocument.DOCUMENT_TYPE;
        }
    }
    RawDocument.DOCUMENT_TYPE = 'RawDocument';
    AAMVA.RawDocument = RawDocument;
})(AAMVA || (AAMVA = {}));
/** HIBC */
export class HIBC {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return HIBC.DOCUMENT_TYPE;
    }
    /** Date of Manufacture */
    get dateOfManufacture() {
        return this.document.fields.find((f) => f.type.name === 'DateOfManufacture');
    }
    /** Expiry Date Day */
    get expiryDateDay() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateDay');
    }
    /** Expiry Date Hour */
    get expiryDateHour() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateHour');
    }
    /** Expiry Date Julian Day */
    get expiryDateJulianDay() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateJulianDay');
    }
    /** Expiry Date Month */
    get expiryDateMonth() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateMonth');
    }
    /** Expiry Date Year */
    get expiryDateYear() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDateYear');
    }
    /** Information whether primary data is present. */
    get hasPrimaryData() {
        return this.document.fields.find((f) => f.type.name === 'HasPrimaryData');
    }
    /** Information whether secondary data is present. */
    get hasSecondaryData() {
        return this.document.fields.find((f) => f.type.name === 'HasSecondaryData');
    }
    /** Labeler Identification Code (LIC) */
    get labelerIdentificationCode() {
        return this.document.fields.find((f) => f.type.name === 'LabelerIdentificationCode');
    }
    /** Labelers Product or Catalog Number (PCN). Alphanumeric data. */
    get labelersProductOrCatalogNumber() {
        return this.document.fields.find((f) => f.type.name === 'LabelersProductOrCatalogNumber');
    }
    /** Link character to link standalone primary and secondary barcodes together. */
    get linkCharacter() {
        return this.document.fields.find((f) => f.type.name === 'LinkCharacter');
    }
    /** Lot Number */
    get lotNumber() {
        return this.document.fields.find((f) => f.type.name === 'LotNumber');
    }
    /** Quantity */
    get quantity() {
        return this.document.fields.find((f) => f.type.name === 'Quantity');
    }
    /** Serial Number */
    get serialNumber() {
        return this.document.fields.find((f) => f.type.name === 'SerialNumber');
    }
    /** Unit of Measure ID, Numeric value only, 0 through 9, where 0 always represents
  a single unit. 1 to 8 are used to indicate different packaging levels above the unit of use.
  The value 9 is used for variable quantity containers when manual key entry or scan of
  a secondary will be used to collect specific quantity data.
  The labeler should ensure consistency in this field within their packaging process.
   */
    get unitOfMeasureID() {
        return this.document.fields.find((f) => f.type.name === 'UnitOfMeasureID');
    }
}
HIBC.DOCUMENT_TYPE = 'HIBC';
HIBC.DATE_OF_MANUFACTURE_FIELD_NAME = 'DateOfManufacture';
HIBC.DATE_OF_MANUFACTURE_FIELD_NAME_NORMALIZED = 'HIBC.DateOfManufacture';
HIBC.EXPIRY_DATE_DAY_FIELD_NAME = 'ExpiryDateDay';
HIBC.EXPIRY_DATE_DAY_FIELD_NAME_NORMALIZED = 'HIBC.ExpiryDateDay';
HIBC.EXPIRY_DATE_HOUR_FIELD_NAME = 'ExpiryDateHour';
HIBC.EXPIRY_DATE_HOUR_FIELD_NAME_NORMALIZED = 'HIBC.ExpiryDateHour';
HIBC.EXPIRY_DATE_JULIAN_DAY_FIELD_NAME = 'ExpiryDateJulianDay';
HIBC.EXPIRY_DATE_JULIAN_DAY_FIELD_NAME_NORMALIZED = 'HIBC.ExpiryDateJulianDay';
HIBC.EXPIRY_DATE_MONTH_FIELD_NAME = 'ExpiryDateMonth';
HIBC.EXPIRY_DATE_MONTH_FIELD_NAME_NORMALIZED = 'HIBC.ExpiryDateMonth';
HIBC.EXPIRY_DATE_YEAR_FIELD_NAME = 'ExpiryDateYear';
HIBC.EXPIRY_DATE_YEAR_FIELD_NAME_NORMALIZED = 'HIBC.ExpiryDateYear';
HIBC.HAS_PRIMARY_DATA_FIELD_NAME = 'HasPrimaryData';
HIBC.HAS_PRIMARY_DATA_FIELD_NAME_NORMALIZED = 'HIBC.HasPrimaryData';
HIBC.HAS_SECONDARY_DATA_FIELD_NAME = 'HasSecondaryData';
HIBC.HAS_SECONDARY_DATA_FIELD_NAME_NORMALIZED = 'HIBC.HasSecondaryData';
HIBC.LABELER_IDENTIFICATION_CODE_FIELD_NAME = 'LabelerIdentificationCode';
HIBC.LABELER_IDENTIFICATION_CODE_FIELD_NAME_NORMALIZED = 'HIBC.LabelerIdentificationCode';
HIBC.LABELERS_PRODUCT_OR_CATALOG_NUMBER_FIELD_NAME = 'LabelersProductOrCatalogNumber';
HIBC.LABELERS_PRODUCT_OR_CATALOG_NUMBER_FIELD_NAME_NORMALIZED = 'HIBC.LabelersProductOrCatalogNumber';
HIBC.LINK_CHARACTER_FIELD_NAME = 'LinkCharacter';
HIBC.LINK_CHARACTER_FIELD_NAME_NORMALIZED = 'HIBC.LinkCharacter';
HIBC.LOT_NUMBER_FIELD_NAME = 'LotNumber';
HIBC.LOT_NUMBER_FIELD_NAME_NORMALIZED = 'HIBC.LotNumber';
HIBC.QUANTITY_FIELD_NAME = 'Quantity';
HIBC.QUANTITY_FIELD_NAME_NORMALIZED = 'HIBC.Quantity';
HIBC.SERIAL_NUMBER_FIELD_NAME = 'SerialNumber';
HIBC.SERIAL_NUMBER_FIELD_NAME_NORMALIZED = 'HIBC.SerialNumber';
HIBC.UNIT_OF_MEASURE_ID_FIELD_NAME = 'UnitOfMeasureID';
HIBC.UNIT_OF_MEASURE_ID_FIELD_NAME_NORMALIZED = 'HIBC.UnitOfMeasureID';
//# sourceMappingURL=BarcodeDocumentModel.js.map